var customRouteObject = customRoute();

/**
 * Object: step
 * Purpose: This object creates and manipulates the DOM for steps in the View. It is currently in use for admin/process.
 */
approvalProcess = function(id) {
	var objApprovalProcess = form();
	var objApprovalProcessList = approvalProcessList();
	var objDialog = dialog();
	var objSmartfield = smartfield();
	var objValidation = validation();

	var url = window.location.pathname.split('/');
	var apID = 0;
	if (url[2] !== undefined) {
		apID = window.location.pathname.split('/')[2].split(':')[1];
	}
	var objDom = dom();
	var entityObject = entity(myUniquer.create());
	var isCustomRoute = Boolean($('#route').length);

	/* initialize growls */
	$('#growls').notify();

	var popitup = function(pageURL,w,h){
		var left = (($(window).width())/2)-(w/2);
		var top = (($(window).height())/2)-(h/2);
		var targetWin = window.open (pageURL, 'PreviewAP', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
	};

	objApprovalProcess.previewApprovalProcess = function(id) {
		popitup('/approvalProcess:' + id + '/preview?limit=0&printNow=0', '750', '500');
	};

	objApprovalProcess.saveCrosslistingOptions = function() {

		var crosslistingOption;

		if ($('#independent:checked').length) {
			crosslistingOption = 'independent';
		} else if ($('#dependent:checked').length) {
			crosslistingOption = 'dependent';
		} else if ($('#parent:checked').length) {
			crosslistingOption = 'parent';
		} else {
			crosslistingOption = 'none';
		}

		apId = $('input[name="id"]').val();

		if (crosslistingOption === 'dependent' || crosslistingOption === 'parent') {
			var dialog = objDialog.createBasicWarningDialog('select-dependent', function(dialog, defaults) {
				// Message

				if (crosslistingOption === 'dependent') {
					message = 'By selecting the dependent option you can no longer add any conditional steps or create custom routes. ' +
							  'Any conditional steps you have already added will also be removed and the custom route decision will be disabled on all steps.<br><br>' +
							   'Are you sure you still want to select dependent as your option for crosslisting?';

				} else {
					message = 'When you switch to Parent type crosslisting, some of the existing options you have selected are not valid and will be reset: <br><br>' +
							  '- You can no longer create custom routes on proposals created from this AP <br>' +
							  ' - Any step with deadlines set to automatically reject will only be enforced on the primary proposal (crosslistings who' +
							  ' have passed this step in the workflow will return to the same step as the primary) <br><br> ' +
							  'Are you sure you still want to select parent as your option for crosslisting?';
				}

				$(dialog).append(message);

				// Actions
				defaults.buttons = {
					'Save': function() {
						objApprovalProcess.crosslistingOption(apId, crosslistingOption);
						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				};

				$(dialog).dialog(defaults);

			});

		} else {
			objApprovalProcess.crosslistingOption(apId, crosslistingOption);
		}
	};

	objApprovalProcess.crosslistingOption = function(apId, crosslistingOption) {

			return $.ajax({
				url: '/admin/approvalProcess:' + apId + '/crosslistingOption.json',
				type: 'put',
				data: {crosslistingOption: crosslistingOption},
				beforeSend: function() {
					objDom.addMask('#curriculog-steps-column-content');
				},
				complete: function() {
					objDom.removeMask('#curriculog-steps-column-content');
				},
				success: function(data) {
					location.href = '/admin/approvalProcess:' + apId + '/form';
				}
			});


	};

	objApprovalProcess.addSortable = function() {

		$('#title-selection').sortable({
			placeholder: "curriculog-draggable-placeholder",
			items: 'li'
		});

		$('#curriculog-steps-column-content').sortable({
			placeholder: "curriculog-draggable-placeholder",
			items: '.step',
			handle: '.section-row-draggable-handle',
			update: function(event, ui) {
				objApprovalProcess.updateStepsOrder($(event.target).parents('li').attr('id'));
			}
		});
	};

	objApprovalProcess.updateForm = function() {
		$.ajax({
			url: '/admin/approvalProcess:' + $('input[name="id"]').val() + '/form',
			type: 'GET',
			beforeSend: function() {
				approvalProcessObject.unbindFieldEvents();
				objDom.addMask('#curriculog-content','Updating');
			},
			complete: function() {
				objDom.removeMask('#curriculog-content');
			},
			success: function(data) {
				var content = $(data).find('#curriculog-fields-column-content');
				$('#curriculog-fields-column-content').contents().remove();
				$('#curriculog-fields-column-content').replaceWith($(content));
				approvalProcessObject.bindFieldEvents();
				Curriculog.Actions.log('ap-form-updated');
			}
		});

	};

	objApprovalProcess.createAPSelect = function(select, noneOption, callback) {
		// select variable could be a class or id. variable should include its type (ie #select-id or .select-id)
		return $.ajax({
			type: 'GET',
			url: '/rpc/ApprovalProcess/getNames.json',
			// async: false,
			success: function(data){
				$(select).find('option').remove();

				// If there is an option for selecting None, add that to the top and select by default
				if (noneOption.length > 0) {
					$('<option value="">' + noneOption + '</option>').appendTo(select);
				}

				$(data).each(function(index, item) {
					$('<option value="'+ item.id +'">' + _.escape(item.name) + '</option>').appendTo(select);
				});

				// If there is a callback defined (like for preselecting an option), run it now
				if (callback) {
					callback();
				}
			}
		});
	};

	objApprovalProcess.createAPSelectForAdvancedSearch = function(select, optGroup, callback) {
		// select variable could be a class or id. variable should include its type (ie #select-id or .select-id)
		return $.ajax({
			type: 'GET',
			url: '/rpc/ApprovalProcess/getNames.json',
			// async: false,
			success: function(data) {
				$optGroup = $(select).find('optgroup[label="' + optGroup + '"]');

				$(data).each(function(index, item) {
					$('<option value="'+ item.id +'">' + item.name + '</option>').appendTo($optGroup);
				});

				// If there is a callback defined (like for preselecting an option), run it now
				if (callback) {
					callback();
				}
			}
		});
	};

	objApprovalProcess.renameProcess = function() {
		var dialog = objDialog.createDOMDialog('change-process-name-dialog', function(dialog, defaults) {
			// Actions
			defaults.buttons = {
				'Rename Approval Process': function() {

					if (objApprovalProcessList.validateNewAP()) {

						$.ajax({
							url: '/approvalProcess:' + $('input[name="id"]').val() + '/name.json',
							type: 'put',
							data: {
								name: $('#curriculog-dialog-new-process-name').val()
							},
							success: function(result) {
								if (parseInt(result.success, 10) > 0) {
									$('#curriculog-fields-column-process-name span').text($('#curriculog-dialog-new-process-name').val());

								} else {
									$('#growls').notify("create","warning-template", {
										title: 'Error Changing Approval Process Name',
										text: 'The Approval Process\'s name was not able to be changed. Please try again or contact support.'
									});
								}

								$(dialog).dialog('close');
							}
						});


					}

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***							SECTION FUNCTIONS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/*
	 * Function addSection
	 * Purpose:
	 * 1.) Creates a fieldset placeholder
	 * 2.) Create Section within the database
	 * 3.) Update the DOM with the new section by replacing the placeholder with the html
	 *		returned from server.
	 */
	objApprovalProcess.addSection = function(button, callback) {

		// create a unique id
		var sid = myUniquer.create();
		var sectionId = 'sec-' + sid;

		// insert a placeholder until it can be populated by the database
		$('<fieldset id="' + sectionId + '"></fieldset>').insertBefore('#curriculog-section-new');

		// set data to default settings
		var data = {
			orderIndex : $('.section:last').index() - 2,
			displayText : 'HEADING'
		};

		// create the heading by AJAX
		$.ajax({
			url: '/admin/approvalProcessSection:' + $('input[name="id"]').val() + '/create.json',
			type: 'POST',
			data: data,
			beforeSend: function() {
				objDom.addMask('#'+sectionId);
			},
			complete: function() {
				objDom.removeMask('#'+sectionId);
			},
			success: function(data) {
				objApprovalProcess.updateDOMSection(sectionId, data.id, true, false);
			}
		});

		if (callback) {
			callback();
		}
	};

	/*
	 * Function updateSection
	 * Purpose:
	 * 1.) Retrieves new html code with new section data
	 * 2.) Updates the DOM with the new HTML Code
	 */
	objApprovalProcess.updateSection = function(input) {
		var sid = $(input).parents('fieldset').attr('id').replace('section-','');
		var displayText = $(input).val();

		$.ajax({
			url: '/admin/approvalProcessSection:' + $('input[name="id"]').val() + '.json',
			type: 'PUT',
			data: {id:sid,displayText:displayText},
			beforeSend: function() {
				objDom.addMask('#'+$(input).parents('section-heading').attr('id'));
			},
			complete: function() {
				objDom.removeMask('#'+$(input).parents('section-heading').attr('id'));
			},
			success: function(data) {
				objApprovalProcess.updateDOMSection($(input).parents('fieldset').attr('id'), data.id, false, true);
			}
		});
	};

	/*
	 * Function: updateDOMSection
	 * Purpose:
	 * 1.) updates all existing sections with new orderIndexes
	 * 2.) retrieves the new section from the database and returns the html for it replacing placeholder
	 */
	objApprovalProcess.updateDOMSection = function(sectionId, id, isNew, update) {
		// update all indexes
		$('.section').each(function(index) {
			$('#' + $(this).attr('id') + '-orderIndex').val(index);
		});

		$.ajax({
			url: '/admin/approvalProcessSection:' + $('input[name="id"]').val() + '.ajax',
			type: 'GET',
			data: {
				id: id,
				display: 'getSection',
				update: update
			},
			success: function(data) {
				if (isNew) {
					$('#' + sectionId).contents().remove();
					$('#' + sectionId).replaceWith(data);

				} else {
					var header = $(data).filter('.section-heading').html();
					var link = $(data).filter('.section-add-row').html();
					$('#' + sectionId).children('div').contents().remove();
					$('#' + sectionId).find('.section-heading').html(header);
					$('#' + sectionId).find('.section-add-row').html(link);
					$('#' + sectionId).find('ul.section-fields').fadeIn('fast');
				}

				// Drag n Drop
				$('#curriculog-fields-column-content ul').sortable({
					placeholder: 'curriculog-draggable-placeholder',
					items: '.section-row:not(.non-sortable)',
					handle: '.section-row-draggable-handle',
					connectWith: '.section-fields',
					update: function(event, ui) {
						approvalProcessObject.updateFieldsOrder($(ui.item).parents('fieldset').attr('id'));
					}
				});

				objApprovalProcess.verticalStretch();
			}
		});
	};

	/*
	 * Function removeSection
	 * Purpose: removes the current section and all its fields from the DOM.
	 * Selecting to delete brings up a warning dialog, since the action of removing
	 * the entire section with fields may not be the user's intention.
	 */

	objApprovalProcess.removeSection = function(button, callback) {

		$(button).closest('.section').addClass('curriculog-remove-warning-highlight');
		var secId = ($(button).closest('.section').attr('id')).replace('section-','');
		var dialog;

		/*
		 * Only remove the section if there are no system required fields. Else Show error
		 */
		var deleteable = true;
		$('#section-' + secId + '-fields li').each(function(index) {
			$(this).children('fieldset').each(function(index) {
				if ($(this).hasClass('system-required') || $(this).hasClass('conditional-field')) {
					deleteable = false;
				}
			});
		});

		if (deleteable) {

			dialog = objDialog.createBasicWarningDialog('remove-section', function(dialog, defaults) {
				// Message
				$(dialog).append('Removing this section will also remove all rows and fields within this section. Are you sure you want to remove this section?');
				// Actions
				defaults.buttons = {
					'Remove Section': function() {
						/* remove the section from the database by it's id. The python model will also
						 * remove all the fields associated with this section so we don't have to do anything else
						 */
						$.ajax({
							url: '/admin/approvalProcessSection:' + $('input[name="id"]').val() + '.json',
							type: 'DELETE',
							data: {id:secId, updateHermes:1},
							beforeSend: function() {
								var fieldsetId = $(button).closest('.section').attr('id');
								objDom.addMask('#'+fieldsetId);
							},
							complete: function() {

								if ($('#hermes').val() === '1') {
									hermesObject.getLegends($('input[name="id"]').val(), function() {
										domObject.verticalStretchForm(col1, col2);
									});

								} else {
									var fieldsetId = $(button).closest('.section').attr('id');
									objDom.removeMask('#'+fieldsetId);
								}

							},
						});

						$(button).closest('.section').remove();

						// update all indexes
						$('.section').each(function(index) {
							$('#' + $(this).attr('id') + '-orderIndex').val(index);
						});

						objApprovalProcess.verticalStretch();

						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				};
				// Cleanup
				defaults.close = function(event, ui) {
					$(button).closest('.section').removeClass('curriculog-remove-warning-highlight');
					$(this).remove();
				};
				$(dialog).dialog(defaults);

			});

		} else {
			dialog = objDialog.createBasicWarningDialog('cannot-remove-section', function(dialog, defaults) {
				// Message
				$(dialog).append('You cannot remove this section because it has system ' +
					'required fields or conditional fields. Please place these system ' +
					'required or conditional fields into another section before removing ' +
					'this one.');

				// Actions
				defaults.buttons = {
					'OK': function() {
						$(this).dialog('close');
					}
				};
				// Cleanup
				defaults.close = function(event, ui) {
					$(button).closest('.section').removeClass('curriculog-remove-warning-highlight');
					$(this).remove();
				};
				$(dialog).dialog(defaults);
			});
		}
	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***							FIELD FUNCTIONS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/*
	 * Function addRow
	 * Purpose: clones an empty row from fields.html.php
	 * and inserts it into the DOM after the last row in the current section.
	 * This function uses DOM ids (row-######) that are for use by the JS only.
	 * NOTE: The fieldset Id is unique from the row Id (in case there are two columns in a row).
	 */
	objApprovalProcess.addRow = function(button) {
		var sectionId = $(button).closest('.section').children('.section-fields').attr('id');
		var Ids = sectionId.match(/section-(.*)-fields/);
		var id = myUniquer.create();
		var rowNode = $('#curriculog-fields-clone-newrow').clone().attr('id','row-' + id);
		rowNode.addClass('non-sortable');
		$('#section-' + Ids[1] + '-fields').append(rowNode);
		$('#row-' + id + ' .section-fieldset').attr('id','fieldset-temp-' + myUniquer.create());

		objApprovalProcess.verticalStretch();

		Curriculog.Actions.log('ap-row-added');
	};

	/*
	 * Function splitRow
	 * Purpose: splits an empty row into two columns, each with the ability to add a new field.
	 * A row can only be split when there is no field inserted. This ability is removed after that.
	 */
	objApprovalProcess.splitRow = function(button) {
		var rowNode = $('#curriculog-fields-clone-splitrow').html();
		var rowId = $(button).closest('.section-row').attr('id');
		$(button).closest('.section-row').addClass('half-field').html(rowNode);

		// Because we replaced the html with rowNode, the button object no longer exists.
		// We need to call based on rowId instead.
		$('#'+rowId+' .section-fieldset').each(function(index) {
			$(this).attr('id', 'fieldset-temp-'+ myUniquer.create());
		});

		Curriculog.Actions.log('ap-row-split');
	};

	objApprovalProcess.isConditional = function(button, itemToRemove) {
		if ($(itemToRemove).hasClass('conditional-field') === false) {
			return false;
		}

		var message = (
			'You cannot remove this field because it is used on a conditional step.' +
			'<br><br>' +
			'To remove this field you must either remove the step that is using it ' +
			'or change the conditional on the step to use a different field.'
		);

		new Curriculog.WarningDialog({
			message: message,
			buttons: {
				OK: function () {
					$(button)
						.closest('.section-fieldset')
						.removeClass('curriculog-remove-warning-highlight');
					this.close();
				}
			}
		});

		return true;
	};

	/*
	 * Function mergeRow
	 * Purpose: Merges two columns into one row. Warning dialog if there is a field in the column being removed.
	 * This function keeps the data based on the way mergeRow is called:
	 * 1) User clicks "delete" on one column: that column and its contents are removed from the DOM.
	 *    The other item maintains its data in a single row.
	 * 2) User clicks "mergeRow" on one column: the other column and its contents are removed from the DOM.
	 *    The merged row maintains its data in a single row.
	 * Once a column has a field, the mergeRow link is gone. User can only click "delete" to merge
	 * If the merged column does not have a field inserted yet, it receives a clone of an empty row.
	 */

	objApprovalProcess.mergeRow = function(button) {
		var rowNode = $('#curriculog-fields-clone-newrow').html();
		var rowId = $(button).closest('.section-row').attr('id');
		$(button).closest('.section-row').removeClass('half-field').html(rowNode);

		// Because we replaced the html with rowNode, the button object no longer exists.
		// We need to call based on rowId instead.
		$('#'+rowId+' .section-fieldset').each(function() {
			$(this).attr('id', 'fieldset-temp-'+ myUniquer.create());
		});

		Curriculog.Actions.log('ap-row-merged')
	};

	objApprovalProcess.isConditional = function(button, itemToRemove) {
		if ($(itemToRemove).hasClass('conditional-field') === false) {
			return false;
		}

		var message = (
			'You cannot remove this field because it is used on a conditional step.' +
			'<br><br>' +
			'To remove this field you must either remove the step that is using it ' +
			'or change the conditional on the step to use a different field.'
		);

		new Curriculog.WarningDialog({
			message: message,
			buttons: {
				OK: function () {
					$(button)
						.closest('.section-fieldset')
						.removeClass('curriculog-remove-warning-highlight');
					this.close();
				}
			}
		});

		return true;
	};


	var SectionRow = Backbone.View.extend({
		isHalfField: function () {
			return this.$el.hasClass('half-field');
		},

		removeHalfField: function () {
			this.$el.removeClass('half-field');
			this.$el.children('.section-fieldset').each(function (index, fieldset) {
				$(fieldset)
					.removeClass('half-field-left')
					.removeClass('half-field-right');
			});
		},
	});

	/*
	 * Function removeRow
	 * Purpose: removes the current row from the DOM. If the row is a column,
	 * deleteRow relies on mergeRow to identify which column to keep.
	 */
	objApprovalProcess.removeRow = function(button) {
		var itemToRemove = $(button).closest('.section-fieldset');
		var rowToRemove = $(itemToRemove).parent('li');
		var isHalfField = false;
		var sectionId = $(itemToRemove).parents('.section').attr('id').replace('section-','');

		// If the column to be removed has a field inserted, confirm the user wants
		// to perform the merge
		if (($(itemToRemove).children('.legend')).length > 0) {
			$(itemToRemove).addClass('curriculog-remove-warning-highlight');

			if (!objApprovalProcess.isConditional(button, itemToRemove)) {
				var dialog = objDialog.createBasicWarningDialog('curriculog-dialog-remove-field-warning', function(dialog, defaults) {
					// Message
					if ($(button).closest('.section-row').hasClass('half-field')) {
						$(dialog).append(
							'You are deleting a field from the form that was split into two ' +
							'columns. You will lose any changes you have made to this field. ' +
							'The other field will also be merged into one row. Are you sure you ' +
							'want to delete this field and merge?'
						);
					} else {
						$(dialog).append(
							'You are deleting a field from the form. You will lose any changes ' +
							'you have made to this field. Are you sure you want to delete it?'
						);
					}
					// Actions
					defaults.buttons = {
						'Delete Field': function() {
							var sectionRow = new SectionRow({
								el: $(button).closest('.section-row'),
							});
							if (sectionRow.isHalfField()) {
								sectionRow.removeHalfField();
								isHalfField = true;
							}

							// remove row from database
							var id = $(itemToRemove).attr('id').replace('fieldset-', '');
							var fieldsetId = $(itemToRemove).attr('id');
							objApprovalProcess.deleteField(id, fieldsetId, isHalfField);

							fieldsetId = $(this).attr('id');
							var apSec = $('#' + fieldsetId).parents('fieldset');

							// remove the dom elements
							$(itemToRemove).remove();
							if (!isHalfField) {
								$(rowToRemove).remove();
							}

							// update all order indexes for this section for all remaining fields
							apSec.children('ul').children('li').each(function(index) {
								$(this).find('input[name$="[orderIndex]"]').val(index);
							});

							$(this).dialog('close');
						},
						Cancel: function() {
							$(this).dialog('close');
						}
					};
					// Cleanup
					defaults.close = function(event, ui) {
						$(button).closest('.section-fieldset').removeClass('curriculog-remove-warning-highlight');
						$(this).remove();
					};
					$(dialog).dialog(defaults);
				});
			}
		} else {
			if ( ($(itemToRemove).siblings('.section-fieldset').children('.legend')).length > 0) {
				// item being removed is an empty half field
				// (we are making half field a full field)
				var sibling = $(itemToRemove).siblings('.section-fieldset:eq(0)');
				$(button).closest('.section-row').removeClass('half-field').children('.section-fieldset').removeClass('half-field-left half-field-right');
				$(button).closest('.section-fieldset').remove();

				// update the other field to be full field
				var id = $(sibling).attr('id').replace('fieldset-','');
				objApprovalProcess.updateField('fieldset-' + id, 'field-' + id, id);
				objApprovalProcess.verticalStretch();
			} else {
				if ($(button).closest('.section-row').hasClass('half-field')) {
					var rowNode = $('#curriculog-fields-clone-newrow').html();
					var rowId = $(button).closest('.section-row').attr('id');
					$(button).closest('.section-row').removeClass('half-field').html(rowNode);

					// Because we replaced the html with rowNode, the button object no longer exists.
					// We need to call based on rowId instead.
					$('#'+rowId+' .section-fieldset').each(function() {
						$(this).attr('id', 'fieldset-'+ myUniquer.create());
					});
				} else {
					$(button).closest('.section-row').remove();
					objApprovalProcess.verticalStretch();
				}
			}
		}
	};

	/*
	 * Function: updateFieldsOrder
	 * Purpose: Updates ordering of fields per section. Whenever, the update event
	 * has been fired from jQuery Drag and Drop then this function gets called to
	 * update the order in the database.
	 */
	objApprovalProcess.updateFieldsOrder = function(fieldsetId) {

		function isInt(n) {
			return typeof n === 'number' && n % 1 === 0;
		}

		var orderIndexes = [];
		var fieldID;

		var sectionId = $('#' + fieldsetId).attr('id').replace('section-','');

		// update all indexes
		$('#' + fieldsetId).children('ul').children('li').each(function(index) {
			$(this).children('fieldset').each(function(idx) {
				fieldID = parseInt($(this).attr('id').replace('fieldset-',''), 10);
				if ( (fieldID !== undefined) && (isInt(fieldID)) ) {
					fieldID = fieldID;
				} else {
					fieldID = 'None';
				}

				if (index in orderIndexes){
					orderIndexes[index].push(fieldID);
				} else {
					orderIndexes[index] = [fieldID];
				}
			});
		});

		data = {
			orderIndexes:orderIndexes,
			sectionId:sectionId
		};

		$.ajax({
			url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/updateFieldsOrder.json',
			type: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: function(data) {
				if (($('#hermes').val() === '1') && (! $('#legends-outdated-message').hasClass('active')) && ($('#hermes-legends li.no-items').length === 0)) {
					hermesObject.getLegends($('input[name="id"]').val(), function() {
						objApprovalProcess.verticalStretch();
					});
				}
			}
		});
	};

	/*
	 * Function deleteField
	 * Purpose: Removes a field from the DB
	 */
	objApprovalProcess.deleteField = function(id,fieldsetId,isHalfField) {
		var apSecId = ($('#' + fieldsetId).parents('fieldset').attr('id')).replace('section-','');

		$.ajax({
			url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/field.json',
			type: 'DELETE',
			data: {
				id: id,
				apSecID: apSecId,
				isHalfField: isHalfField,
				updateHermes: 1
			},
			beforeSend: function() {
				objDom.addMask('#'+fieldsetId);
			},
			complete: function() {
				objDom.removeMask('#'+fieldsetId);
			},
			success: function() {
				// This will find and remove the corresponding option for the
				// conditional-step field select in any open step with an open
				// conditional section.
				// var option = $('.open-summary [id$="-mandatory-field"] [value="' + id + '"]');
				// option.remove();
				objApprovalProcess.updateConditionalDropdowns();
				if (($('#hermes').val() === '1') && (! $('#legends-outdated-message').hasClass('active')) && ($('#hermes-legends li.no-items').length === 0)) {
					hermesObject.getLegends($('input[name="id"]').val(), function() {
						objApprovalProcess.verticalStretch();
					});
				} else {
					objApprovalProcess.verticalStretch();
				}
			},
      error: function(){
        $('#growls').notify('create', 'warning-template',
          {
            title: 'An Error Occured',
            text: 'Unable to delete the Approval Process Field. Please try again or contact support.'
          },
          {expires: false}
        );
      }
		});

	};

	objApprovalProcess.updateConditionalDropdowns = function() {
		var id = $('input[name="id"]').val();

		$.ajax({
			url: '/admin/approvalProcess:' + id + '/mandatoryFields.json',
			type: 'GET',
			data: {id:id},
			beforeSend: function() {
				objDom.addMask('.step fieldset[id$="mandatory-conditions"]');
			},
			success: function(data) {
				$('.step .step-field select[id$="mandatory-field"]').each(function(index, item){
					var selectedItem = $(item).val();
					$(item).empty();
					$(item).append('<option value="null">Select a Field</option>');
					$.each(data.fields, function(index, field) {
							$(item)
							.append($("<option></option>")
							.attr("value",field.id)
							.text(field.name));
					});
					$(item).find('option[value="' + selectedItem + '"]').prop('selected', true);
				});
				objDom.removeMask('.step fieldset[id$="mandatory-conditions"]');
			}
		});
	};

	/*
	 * Function addField
	 * Purpose: Launches a dialog allowing the user to select the type of field they want to add.
	 * Pulls the dialog content from fields.html.php. Dialog uses jquery-ui's dialog.
	 * Loads the button's fieldset id into a hidden field in the dialog for reinsertion.
	 */
	objApprovalProcess.addField = function(button) {
		$('#curriculog-dialog-add-field li').removeClass('active');
		$('#curriculog-dialog-add-field #curriculog-dialog-temp-id').val($(button).closest('.section-fieldset').attr('id'));
		var dialog = objDialog.createDOMDialog('curriculog-dialog-add-field', function(dialog, defaults) {
			// Actions
			defaults.dialogClass = 'curriculog-dialog single-field';
			defaults.buttons = {
				'Add Field': function() {
					objApprovalProcess.insertField(button, dialog);
					$(this).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);

		});
	};

	/*
	 * Function insertField
	 * Purpose: inserts the selected field type into the DOM.
	 * Section 1) Variables are declared.
	 * Section 2) Field Options Clone is created from fields.html.php based on type of field.
	 *            Nodes are located to remove field attributes that are not necessary for this field type.
	 * Section 3) Current row is prepared by removing buttons and inserting the appropriate field clone.
	 * Section 4) Field attributes (label, id, name) are given DOM id values.
	 * Section 5) Field Options Clone is inserted into DOM behind the delete row button.
	 * Section 6) Dialog is closed.
	 */
	objApprovalProcess.insertField = function (button, dialog) {
		/********************************
			Section 1) Declare variables
		 ********************************/
		var fieldsetId = $('#curriculog-dialog-temp-id').val();

		$('#' + fieldsetId).parents('li').removeClass('non-sortable');

		// fieldType: get the field user wants to place into the row (remove 'new-' from the string)
		var fieldType = ($('#curriculog-dialog-add-field li.active button').attr('class')).match(/new-.*/);
		fieldType = fieldType[0].substring(4);

		// fieldPosition: gets the radio/checkbox orientation :: horizontal or vertical
		var fieldPosition = fieldType.match(/(.*)-(.*)/);

		// fieldId: compile the final DOM id to be used for the new field (including, if two columns exist, the column direction)
		var fieldDOMId = getFieldDOMId(fieldsetId);

		// fieldName: private function gets the random Id for the field and returns it in proper bracket format for the field name
		var fieldName = getFieldName(fieldDOMId);

		// mask the row to prevent changes to the row items before the id is set
		var row = $('#' + fieldsetId).parents('li');
		objDom.addMask(row);


		/********************************
			Section 2) Clone Field Options
		 ********************************/
		// DOM id: field-######-options
		var Options = $('#curriculog-dialog-field-options').clone().attr('id', fieldDOMId + '-options');

		// Clone appropriate options
		var $self    = $(this),
			self     = this,
			$sfOptions = $(Options).find('.smartfield-option'),
			$tfOptions = $(Options).find('.text-option'),
			$fieldType = $(Options).find('input[name="[fieldType]"]'),
			$fieldOptions = $(Options).find('li');

		if (fieldType === 'text') {
			$sfOptions.remove();

		} else if (fieldType === 'smartfield') {
			$tfOptions.remove();

		} else {
			$tfOptions.remove();
			$sfOptions.remove();

			// Remove all field options except positioning hidden fields for subheading and description
			if ((fieldType === 'subheading') || (fieldType === 'description')) {
				$fieldOptions.each(function() {
					if (! $(this).hasClass('all-field-types') ) {
						$(this).remove();
					}
				});
			}
		}

		//Fill in the value of the fieldtype hidden field with FieldType
		$fieldType.val(fieldType);

		/********************************
			Section 3) Prepare current row
		 ********************************/
		// Remove buttons
		$('#'+ fieldsetId + ' .curriculog-split-widget').remove();
		$('#'+ fieldsetId + ' .curriculog-merge-widget').remove();
		$('#'+ fieldsetId + ' .curriculog-add-widget').remove();
		$('#'+ fieldsetId + ' .delete-row').remove();

		// Prepare clone and insert field into DOM into li with ID from hidden field
		var strClone = '';

		if ($.inArray(fieldType, ['text','textarea','smartfield','subheading','description','blank']) !== -1) {

			strClone = $('#curriculog-fields-clone-'+ fieldType + ' .section-fieldset');
			strCloneClass = $(strClone).attr('class');
			$('#' + fieldsetId).html($(strClone).html());
			$('#' + fieldsetId).addClass(strCloneClass);

		} else {
			strClone = $('#curriculog-fields-clone-'+ fieldPosition[1] + ' .section-fieldset');
			strCloneClass = $(strClone).attr('class');
			$('#' + fieldsetId).addClass('radio-checkbox-'+fieldPosition[2]).html($(strClone).html());
			$('#' + fieldsetId).addClass(strCloneClass);
		}

		/************************************
			Section 4) Assign Field Attributes
		 ************************************/

		// INPUT: CHECKBOX/RADIOS
		// Assign Labels a unique for attribute that matches the form element id
		// DOM for: field-######(-[index])?
		if ($('#'+ fieldsetId + ' .option-group').length > 1) {
			$('#'+ fieldsetId + ' .option-group').each(function(index) {
				$(this).attr('id', fieldDOMId + '-'+ index);
			});
		} else {
			$('#'+ fieldsetId + ' .option-group').attr('id', fieldDOMId);
		}

		// INPUT: TEXT
		// Assign Input fields (text, checkbox, radio) a unique name and id
		// DOM Id: field-######(-index)? | Name: field[#####][IGNORE]([index])?
		if ($('#'+ fieldsetId + ' input:not(.checkbox-radio-label)').length > 1) {
			$('#'+ fieldsetId + ' input:not(.checkbox-radio-label)').each(function(index) {
				$(this).attr('name', fieldName +'[IGNORE]['+ index + ']').attr('id', fieldDOMId + '-'+ index);
			});

		// Assign Subheading fields a unique name and id
		// DOM Id: subheading-###### | Name: field[#####][subheading]
		} else if (fieldType === 'subheading') {
			$('#'+ fieldsetId + ' input').attr('id', fieldDOMId.replace('field',fieldType)).attr('name', fieldName +'[displayText]');

		} else if (fieldType === 'blank') {
			$('#'+ fieldsetId + ' input').attr('id', fieldDOMId.replace('field',fieldType)).attr('name', fieldName +'[displayText]');

		// Assign all other inputs a unique name and id
		// DOM Id: field-###### | Name: field[#####][IGNORE]
		} else {
			$('#'+ fieldsetId + ' input').attr('id', fieldDOMId).attr('name', fieldName +'[IGNORE]');
		}

		// INPUT: TEXT FOR CHECKBOX/RADIO LABELS
		// Assign Checkbox/Radio Input field for Option Text a unique name (no label is required)
		// DOM Id: field-######-label(-index)? | Name: field[#####][label]([index])?
		if ($('#'+ fieldsetId + ' input.checkbox-radio-label').length > 1) {
			$('#'+ fieldsetId + ' input.checkbox-radio-label').each(function(index) {
				$(this).attr('id', fieldDOMId + '-options-' + index).attr('name', fieldName + '[options][' + index + ']');
			});
		}

		// SMARTFIELDS
		// Assign smartfield a unique name and id
		// DOM name/id: field-######
		$('#'+ fieldsetId + ' .curriculog-smartfield-dropzone').attr('id',fieldDOMId);

		// DESCRIPTIONS
		// Assign Description fields a different name and id field type
		// DOM id (description): description-##### | Name: field[#####][description]
		if (fieldType === 'description') {
			$('#'+ fieldsetId + ' textarea').attr('id', fieldDOMId.replace('field',fieldType)).attr('name', fieldName +'[displayText]');

		// Assign all other textarea fields a different name and id field type
		// DOM id (textarea): field-##### | Name: field[#####][IGNORE]
		} else {
			$('#'+ fieldsetId + ' textarea').attr('id',fieldDOMId).attr('name', fieldName +'[IGNORE]');
		}


		/********************************
			Section 5) Insert Field Options
		 ********************************/
		$(Options).insertAfter($('#'+ fieldsetId + ' .remove-row'));

		// Modify the names, ids and labels of the field option attributes to reflect the field to which they belong
		$('#'+fieldDOMId+'-options li').find('input,select,textarea').each(function() {
			var oldFieldName = $(this).attr('name').match(/\[(.*)\]/);
			$(this).attr('name', getFieldName(''+fieldDOMId+'') + '[' + oldFieldName[1] + ']').attr('id', fieldDOMId + '-' + oldFieldName[1]);
			$(this).prev('.option-group').attr('id', fieldDOMId + '-' + oldFieldName[1]);
			// Change label to match
			$(this).closest('li').find('label').attr('for', fieldDOMId + '-' + oldFieldName[1]);
		});

		/********************************
			Section 6) Close the Dialog
		 ********************************/
		//close dialog
		$(dialog).dialog('close');


		/********************************
			Section 7)
		 ********************************/
		var itemToRemove = $('#'+ fieldsetId).siblings('.section-fieldset').children('.merge-row');
		// If the column to be removed has a field inserted, confirm the user wants to perform the merge
		if ( itemToRemove.length > 0) {
			itemToRemove.remove();
		}

		$('#' + fieldDOMId + '-displayText').val(fieldType + ' Field');
		objApprovalProcess.createDBField(fieldsetId,fieldDOMId);

	};

	objApprovalProcess.validateCreateField = function(fieldId) {
		$.validity.start();
		$('#' + fieldId + '-maxLength').match('number');
		var result = $.validity.end();
		return result.valid;
	};

	objApprovalProcess.createDBField = function(fieldsetId, fieldId) {
		// get the orderIndex and row of the field
		var orderIndex = $('#' + fieldsetId).parents('ul').children('li').index($('#' + fieldsetId).parents('li'));
		var row = $('#'+fieldsetId).parents('li');

		// get whether this field is part of a split row
		if ($('#' + fieldsetId).hasClass('half-field-left')) {
			halfFieldPos = 1;
			halfField = 1;
		} else if ($('#' + fieldsetId).hasClass('half-field-right')) {
			halfFieldPos = 2;
			halfField = 2;
		} else {
			halfFieldPos = 0;
			halfField = 0;
		}

		//get whether the row has both half fields completed
		var complete = 1;
		if (halfField > 0) {
			var siblingId = $('#' + fieldsetId).siblings('.section-fieldset').attr('id').match(/fieldset-(temp-)?\d*/);
			if ((siblingId.length > 1) && (siblingId[1] !== undefined)) {
				complete = 0;
			}
		}

		var fieldType = $('#' + fieldId + '-fieldType').val();

		// set default options for checkboxes
		options = [];
		if (fieldType == 'checkbox-vertical' || fieldType === 'checkbox-horizontal') {
			options = ['New Option'];
		} else if (fieldType == 'radio-vertical' || fieldType === 'radio-horizontal') {
			options = ['New Option','New Option'];
		}

		// get the section id this field is associated with
		var sectionId = ($('#' + fieldsetId).parents('fieldset').attr('id')).match(/section-(\d*)/)[1];

		// special case for smartfields
		var maxLength;
		if ($('#' + fieldId + '-maxLength').is(':checkbox')) {
			maxLength = $('#' + fieldId + '-maxLength:checked').length ? $('#' + fieldId + '-maxLength').val() : 0;
		} else {
			maxLength = $('#' + fieldId + '-maxLength').val();
		}

		var displayText = $('#' + fieldId + '-displayText').val();
		if (displayText) {
			displayText = displayText.charAt(0).toUpperCase() + displayText.slice(1);
		}

		// get other data
		var fieldData = {
			displayText : displayText,
			validation : $('#' + fieldId + '-validation').length ? $('#' + fieldId + '-validation').val() : 'none',
			maxLength : maxLength,
			helpText : $('#' + fieldId + '-helpText').val(),
			required : $('#' + fieldId + '-required:checked').length ? $('#' + fieldId + '-required').val() : 0,
			summary : $('#' + fieldId + '-summary:checked').length ? $('#' + fieldId + '-summary').val() : 0,
			searchable : $('#' + fieldId + '-searchable:checked').length ? $('#' + fieldId + '-searchable').val() : 0,
			importLock : $('#' + fieldId + '-importLock:checked').length ? $('#' + fieldId + '-importLock').val() : 0,
			userTracking : $('#' + fieldId + '-userTracking:checked').length ? $('#' + fieldId + '-userTracking').val() : 0,
			orderIndex : orderIndex,
			fieldType : $('#' + fieldId + '-fieldType').val(),
			halfField : halfField,
			sectionId : sectionId,
			systemRequired : $('#' + fieldId + '-systemRequired').val(),
			title : $('#' + fieldId + '-title').val(),
			dataset : $('#' + fieldId + '-dataset').val(),
			halfFieldPos : halfFieldPos,
			options : options,
			complete: complete,
			display: 'getField',
			updateHermes: 1
		};

		$.ajax({
			url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/createField.ajax',
			type: 'POST',
			data: fieldData,
			complete: function() {
				objDom.removeMask(row);
			},
			success: function(data) {
				$('#' + fieldsetId).contents().remove();
				$('#' + fieldsetId).replaceWith(data);

				if (fieldType !== 'subheading' && fieldType !== 'description' && fieldType !== 'blank') {
					objApprovalProcess.showOptions($(data).find('.field-options'), 'update');
				}

				var id = $(data).find('.fields-description').attr('id');
				// if type is description, init ckeditor actions
				if (fieldType == 'description') {
					objApprovalProcess.enableRichText($('#' + id));
				}

				if (($('#hermes').val() === '1')
						&& ($('#legends-outdated-message').hasClass('active') === false)
						&& ($('#hermes-legends li.no-items').length === 0)) {
					hermesObject.getLegends($('input[name="id"]').val(), function() {
						domObject.verticalStretchForm(col1, col2);
					});
				}

				objApprovalProcess.updateConditionalDropdowns();

				objApprovalProcess.verticalStretch();

				Curriculog.Actions.log('ap-field-added');
			}
		});
	};


	objApprovalProcess.updateField = function(fieldsetId, fieldId, id) {
		// get the orderIndex of the field
		var orderIndex = $('#' + fieldsetId).parents('ul').children('li').index($('#' + fieldsetId).parents('li'));

		// get whether this field is part of a split row
		if ($('#' + fieldsetId).hasClass('half-field-left')) {
			halfField = 1;
		} else if ($('#' + fieldsetId).hasClass('half-field-right')) {
			halfField = 2;
		} else {
			halfField = 0;
		}

		//get whether the row has both half fields completed
		var complete = 1;
		if (halfField > 0) {
			var siblingId = $('#' + fieldsetId).siblings('.section-fieldset').attr('id').match(/fieldset-(temp-)?\d*/);
			if ((siblingId.length > 1) && (siblingId[1] !== undefined)) {
				complete = 0;
			}
		}

		// get the section id this field is associated with
		var sectionId = ($('#' + fieldsetId).parents('fieldset').attr('id')).match(/section-(\d*)/)[1];

		// special case for smartfields
		var maxLength;
		if ($('#' + fieldId + '-maxLength').is(':checkbox')) {
			maxLength = $('#' + fieldId + '-maxLength:checked').length ? $('#' + fieldId + '-maxLength').val() : 0;
		} else {
			maxLength = $('#' + fieldId + '-maxLength').val();
		}

		// get options
		options = [];

		var fieldType = $('#' + fieldId + '-fieldType').val();
		if (fieldType === 'checkbox-vertical' || fieldType === 'radio-vertical') {
			$('#' + fieldsetId).find('.checkbox-radio-label').each(function(index) {
				options[index] = $(this).val();
			});

		} else if (fieldType === 'checkbox-horizontal' || fieldType === 'radio-horizontal') {
			$('#' + fieldsetId).find('.checkbox-radio-label').each(function(index) {
				options[index] = $(this).val();
			});
		}

		var updateStep = false;

		if (fieldType === 'smartfield'){
			updateStep = true;
		}

		// get other data
		var fieldData = {
			id: id,
			displayText : $('#' + fieldId + '-displayText').val(),
			validation : $('#' + fieldId + '-validation').length ? $('#' + fieldId + '-validation').val() : 'none',
			maxLength : maxLength,
			helpText : $('#' + fieldId + '-helpText').val(),
			required : $('#' + fieldId + '-required:checked').length ? $('#' + fieldId + '-required').val() : 0,
			summary : $('#' + fieldId + '-summary:checked').length ? $('#' + fieldId + '-summary').val() : 0,
			searchable : $('#' + fieldId + '-searchable:checked').length ? $('#' + fieldId + '-searchable').val() : 0,
			userTracking : $('#' + fieldId + '-userTracking:checked').length ? $('#' + fieldId + '-userTracking').val() : 0,
			importLock : $('#' + fieldId + '-importLock:checked').length ? $('#' + fieldId + '-importLock').val() : 0,
			richText : $('#' + fieldId + '-richText:checked').length ? $('#' + fieldId + '-richText').val() : 0,
			crosslistingField : $('#' + fieldId + '-crosslistingField:checked').length ? $('#' + fieldId + '-crosslistingField').val() : 0,
			orderIndex : orderIndex,
			fieldType : $('#' + fieldId + '-fieldType').val(),
			halfField : halfField,
			sectionId : sectionId,
			systemRequired : $('#' + fieldId + '-systemRequired').val(),
			dataset : $('#' + fieldId + '-dataset').val(),
			title : $('#' + fieldId + '-title').val(),
			options : options,
			complete: complete,
			display: 'getField',
			updateHermes: 1
		};

		$.ajax({
			// url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/updateField.json',
			url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/updateField.ajax',
			type: 'PUT',
			data: fieldData,
			async: false,
			beforeSend: function() {
				objDom.addMask('#'+fieldsetId);

			},
			complete: function() {
				objDom.removeMask('#'+fieldsetId);
			},
			success: function(data) {
				$('#' + fieldsetId).contents().remove();
				$('#' + fieldsetId).replaceWith(data);

				// if type is smartfield, load datasets
				if ($('#' + fieldsetId).find('.selected-entities').length > 0) {
					objSmartfield.buildDatasets();
				}

				// if type is description, init ckeditor actions
				if ($('#field-' + id).hasClass('fields-description')) {
					objApprovalProcess.enableRichText($('#field-' + id));
				}

				if (($('#hermes').val() === '1') && (! $('#legends-outdated-message').hasClass('active')) && ($('#hermes-legends li.no-items').length === 0)) {
					hermesObject.getLegends($('input[name="id"]').val(), function() {
						objApprovalProcess.verticalStretch();
					});
				} else {
					objApprovalProcess.verticalStretch();
				}
				objApprovalProcess.updateConditionalDropdowns();
				if (updateStep === true){
						objApprovalProcess.getSteps();
				}
			}
		});

	};

	/**
	 * This is a handler for the CKEdior blur event. (It's not a jQuery event)
	 */
	objApprovalProcess.saveInstructions = function (event) {
		var fieldID = this.name.replace('field-','');
		var fieldsetId = 'fieldset-' + fieldID;
		var fieldDOMId = 'field-' + fieldID;
		objApprovalProcess.updateInstructions(fieldsetId, fieldDOMId, fieldID);
	};

	objApprovalProcess.updateInstructions = function(fieldsetId,fieldId,id) {
		// get the orderIndex of the field
		var orderIndex = $('#' + fieldsetId).parents('ul').children('li').index($('#' + fieldsetId).parents('li'));

		// get whether this field is part of a split row
		if ($('#' + fieldsetId).hasClass('half-field-left')) {
			halfField = 1;
		} else if ($('#' + fieldsetId).hasClass('half-field-right')) {
			halfField = 2;
		} else {
			halfField = 0;
		}

		//get whether the row has both half fields completed
		var complete = 1;
		if (halfField > 0) {
			var siblingId = $('#' + fieldsetId).siblings('.section-fieldset').attr('id').match(/fieldset-(temp-)?\d*/);
			if ((siblingId.length > 1) && (siblingId[1] !== undefined)) {
				complete = 0;
			}
		}

		// get the section id this field is associated with
		var sectionId = ($('#' + fieldsetId).parents('fieldset').attr('id')).match(/section-(\d*)/)[1];

		// get other data
		var fieldData = {
			id: id,
			displayText : $('#' + fieldId).val(),
			summary : $('#' + fieldId + '-summary:checked').length ? $('#' + fieldId + '-summary').val() : 0,
			searchable : $('#' + fieldId + '-searchable:checked').length ? $('#' + fieldId + '-searchable').val() : 0,
			orderIndex : orderIndex,
			fieldType : $('#' + fieldId + '-fieldType').val(),
			halfField : halfField,
			sectionId : sectionId,
			systemRequired : $('#' + fieldId + '-systemRequired').val(),
			title : $('#' + fieldId + '-title').val(),
			complete: complete,
			display: 'getField',
		};

		$.ajax({
			// url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/updateInstructions.json',
			url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/updateInstructions.ajax',
			type: 'PUT',
			data: fieldData,
			beforeSend: function() {
				objDom.addMask('#'+fieldsetId);
				if (fieldData.fieldType === 'description') {
					objApprovalProcess.disableRichText($('#field-' + fieldData.id));
				}
			},
			complete: function() {
				objDom.removeMask('#'+fieldsetId);
			},
			success: function(data) {
				$('#' + fieldsetId).contents().remove();
				$('#' + fieldsetId).replaceWith(data);

				if ($('#field-' + id).hasClass('fields-description')) {
					objApprovalProcess.enableRichText($('#field-' + id));
				} else {
					objApprovalProcess.verticalStretch();
				}
				Curriculog.Actions.log('ap-field-saved');
			}
		});
	};

	objApprovalProcess.enableRichText = function (field) {
		$(field).ckeditor();
		var cke = $(field).ckeditorGet();

		cke.on('instanceReady', function (event) {
			$(event.editor.element.$).removeAttr('title');
			objApprovalProcess.verticalStretch();
		});

		cke.on('blur', objApprovalProcess.saveInstructions);
	};

	objApprovalProcess.disableRichText = function (field) {
		var id = field.attr('id');
		var editor = CKEDITOR.instances[id];
		if (editor) {
			editor.destroy(true);
		}
	};


	/*
	 * Function showOptions
	 * Purpose: Launches a dialog allowing the user to edit the field Options for their new field.
	 * Pulls the dialog content from fields.html.php. Dialog uses jquery-ui's dialog.
	 * Once the dialog is initialized, the node is stripped from the field and kept in the dialog.
	 * All input names are replaced with the following: field[#####][field name]
	 * Hidden field values are processed using the form submission preProcesser.
	 * Once the form field has been named, its label name is placed in the DOM when the Dialog is closed.
	 *
	 * hasErrors is a global variable defined in default.html.php that is used by approvalProcessForm.js to determine
	 * whether to save the field options or to close/cancel the box as expected.
	 */
	objApprovalProcess.showOptions = function(obj,type) {

		var fieldsetId = $(obj).parents('fieldset').attr('id');
		var fieldDOMId = ($(obj).parents('fieldset').attr('id')).replace('fieldset','field');

		var dialog = objDialog.createDOMDialog(fieldDOMId+'-options', function(dialog, defaults) {

			// rebuild datasets
			if ($('#' + fieldDOMId + '-fieldType').val() == 'smartfield') {
				objSmartfield.buildDatasets();
			}

			// if crosslistings disabled, crosslistingField should be disabled
			if (($('#none:checked').length) || (! $('.save-crosslistingOptions').length)){
				$('#' + fieldDOMId + '-crosslistingField').attr('disabled',true);
			}

			// Actions
			defaults.dialogClass = 'curriculog-dialog process-field-options';
			if ($('#' + fieldsetId + ' .options-view-widget').length > 0) {
				defaults.buttons = {
					'Ok': function() {
						$(this).dialog('close');
						$("body").css("overflow", "scroll");
					}
				};
			} else {

				defaults.buttons = {
					'Save Options': function() {
						valid = true;
						$(this).find('input.required').each(function(index, input){
							if ( objValidation.isEmpty($(input).val()) ){
								objValidation.addError(input, 'default', true, true, function(){});
								valid = false;
							} else {
								objValidation.removeError(input, 'default');
							}
						});

						if (valid && objApprovalProcess.validateCreateField(fieldDOMId)) {
							var id = fieldDOMId.replace('field-','');
							objApprovalProcess.updateField(fieldsetId, fieldDOMId, id);

							$(this).dialog('destroy');
							$(this).remove();
							$("body").css("overflow", "scroll");
						}
					},
					Cancel: function() {
						// close the dialog, but don't destroy it, so it can be
						// reopened for this field again if necessary
						$(this).dialog('close');
						$("body").css("overflow", "scroll");
					}
				};
			}

      // activate participant participantpicker
      var options = {
  			'buttonText': 'Add Participant',
  			'dbData': '',
  			'type': 'transparency',
  			'showUsers':true,
  			'showRoles':true,
  			'showRoleTypes':true,
  			'selectEmpty':true,
        'selectOne': false,
        'roleTypeContainer': '#curriculog-steps-column-available-role-types-transparency',
  			'hierarchyContainer': '#curriculog-steps-column-available-roles-and-users-transparency',
  			'dialogId': '#curriculog-steps-select-participant-transparency',
  			'selectorId': '#curriculog-steps-column-available-participant-transparency',
  		};
  		// Click Event for opening the participant dialog.
  		$('.type-transparency.participant-picker').participantpicker(options);
			$(dialog).dialog(defaults);
		});
	};

	/*
	 * Function addOption
	 * Purpose: Adds a new radio or checkbox to a set by cloning the last item in the requested set
	 * and advancing the DOM id/name and value of the Option text. Inserts at the bottom of the list.
	 */
	objApprovalProcess.addOption = function(button) {

		var fieldsetId = $(button).parents('div').parents('fieldset').attr('id');
		var orderIndex = $(button).parents('.option-groups').children().length - 1;

		var data = {
			orderIndex : orderIndex,
			fieldId: $(button).parents('div').parents('fieldset').attr('id').replace('fieldset-', ''),
			display: 'getOption'
		};

		// create the heading by AJAX
		$.ajax({
			url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/createOption.ajax',
			type: 'POST',
			data: data,
			beforeSend: function() {
				objDom.addMask('#' + fieldsetId);
			},
			complete: function() {
				objDom.removeMask('#' + fieldsetId);
			},
			success: function(data) {
				$(data).insertBefore(button);
				objApprovalProcess.verticalStretch();
				Curriculog.Actions.log('ap-field-option-added');
			}
		});
	};

	objApprovalProcess.updateOption = function(id, orderIndex, value) {
		$.ajax({
			url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/updateOption.ajax',
			type: 'PUT',
			data: {id:id, orderIndex:orderIndex, value: value, display: 'getOption'},
			beforeSend: function() {
				objDom.addMask('#fieldset-' + id);
			},
			complete: function() {
				objDom.removeMask('#fieldset-' + id);
			},
			success: function(data) {
				$('#field-' + id + '-' + orderIndex).closest('option-group').replaceWith(data);
				objApprovalProcess.verticalStretch();
				Curriculog.Actions.log('ap-field-option-updated');
			}
		});
	};

	/*
	 * Function deleteOption
	 * Purpose: Adds a new radio or checkbox to a set by cloning the last item in the requested set
	 * and advancing the DOM id/name and value of the Option text. Inserts at the bottom of the list.
	 */
	objApprovalProcess.removeOption = function(button) {

		var dialog = objDialog.createBasicWarningDialog('remove-option-warning-dialog', function(dialog, defaults) {
			$(dialog).append('Are you sure you want to remove this option?');

			defaults.buttons = {
				'Delete Option': function() {

					var fieldsetId = $(button).parents('.option-group').parents('fieldset').attr('id');
					var fieldId = fieldsetId.replace('fieldset-','');
					var data = $(button).parents('.option-group').find('input.checkbox-radio-option').attr('id').replace('field-','').split('-');
					var id = data[0];
					var orderIndex = data[1];
					var siblings = $(button).parents('.option-group').siblings();


					$.ajax({
						url: '/admin/approvalProcessField:' + $('input[name="id"]').val() + '/option.json',
						type: 'DELETE',
						data: {id:id,orderIndex:orderIndex},
						beforeSend: function() {
							objDom.addMask('#' + fieldsetId);
						},
						complete: function() {
							objDom.removeMask('#' + fieldsetId);
						},
						success: function() {
							$(button).parents('.option-group').remove();
							var len = siblings.length;
							siblings.each(function( index ) {
							  if ((index != len - 1)){
								  var name = $(this).find('input.checkbox-radio-option').attr('id');
								  var last_index =  name.lastIndexOf("-");
								  var prefix = name.substring(0, (last_index + 1));
								  $(this).find('input.checkbox-radio-option').attr('id', (prefix + index));
							  }
							});
							Curriculog.Actions.log('ap-field-option-deleted');
						}
					});
					$(this).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			defaults.close = function() {
				$(button).parents('.option-group').removeClass('curriculog-remove-warning-highlight');
				objApprovalProcess.verticalStretch();
			};

			$(dialog).dialog(defaults);
		});
	};

  objApprovalProcess.updateFieldTransparency = function(selector, data){
    $(selector).replaceWith(data);
  };

  objApprovalProcess.checkConditional = function(callback) {
	var returnData = true;
	var numConditionals = $('#steps').find('ul').children('li.step-conditional').length;
	var numMandatory = $('#steps').find('ul').children('li.step-mandatory').length;
	var dialog;
	var emptyVotes = 0;
	var emptyParticipation = 0;
	var validateVoteAndParticipation = 0;
	var hermesEnabled = parseInt($('#hermesEnabled').val());
	var hermesValid = parseInt($('#hermes').val());
	var importRequired = parseInt($('#import-required').val());
	var noLegends = $('#hermes-legends li.no-items').length;


	$('#steps .step').each(function(index) {
		stepID = $(this).attr('id').replace('step-','');
		if ($('#step-' + stepID + '-decision-vote').is(':checked') && $('#step-' + stepID + '-voteThreshold').val() == ''){
			emptyVotes++;
		}
		if ($('#step-' + stepID + '-decision-participation').is(':checked') && $('#step-' + stepID + '-participationThreshold').val() == ''){
			emptyParticipation++;
		}
		if (objApprovalProcess.validateVoteAndParticipation(stepID) == false){
			validateVoteAndParticipation ++;
		}

	});


	var emptyConditionalFieldOptions = false;
	$('.conditional-field.radio-checkbox-vertical, .conditional-field.radio-checkbox-horizontal').each(function(index, item) {
		if ($(this).find('.checkbox-radiobox-option').length === 0) {
			emptyConditionalFieldOptions = true;
		}
	});

	if (emptyConditionalFieldOptions) {
		dialog = objDialog.createBasicWarningDialog('empty-conditional-warning-dialog', function(dialog, defaults) {
			$(dialog).append('One or more conditional fields on this Approval Process has no options. The conditional step will never meet its condition. Please add at least one option to your checkbox or radio button conditional fields.');

			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});

	} else if ($('#legends-outdated-message').hasClass('active')) {
		dialog = objDialog.createBasicWarningDialog('out-of-date-legends', function(dialog, defaults) {
			$(dialog).append('This Approval Process has legends that are out of date. Until these legends are fixed, unlaunched proposals ');
			$(dialog).append('created from this Approval Process will be unable to import from the affected External System. To fix this error, ');
			$(dialog).append('click the Legends tab and follow the instructions provided.');

			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});

	} else if (numMandatory === 0 && numConditionals > 0) {
		dialog = objDialog.createBasicWarningDialog('conditional-warning-dialog', function(dialog, defaults) {
			$(dialog).append('All your steps are conditional steps. A proposal must meet at least one condition else it will not be able to be launched.');

			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
					if (callback) {
						callback();
					}
				}
			};
			$(dialog).dialog(defaults);
		});

	} else if (emptyVotes > 0 || emptyParticipation > 0 || validateVoteAndParticipation > 0) {
		dialog = objDialog.createBasicWarningDialog('decisions-warning-dialog', function(dialog, defaults) {
			$(dialog).append('Vote threshold must be a number between 1 and 100, participation threshold must be a number between 1 and 100.');

			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});

	} else if (importRequired === 1 && hermesEnabled === 1 && hermesValid === 1 && noLegends === 1) {
		dialog = objDialog.createBasicWarningDialog('imported-required-warning-dialog', function(dialog, defaults) {
			$(dialog).append('When Import Required is selected, you must create at least one legend for the Approval Process.');

			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});

	}

	else {
		if (callback) {
			callback();
		}
	}

};


	objApprovalProcess.bindFieldEvents = function() {
		// Init rich-text with ckeditor
		$('.fields-description').ckeditor();
		$('.fields-description').each(function() {
			var cke = $(this).ckeditorGet();
			cke.on('instanceReady', function(e) {
				$(e.editor.element.$).removeAttr('title');
				domObject.verticalStretchForm(col1, col2);
			});

			cke.on('blur', objApprovalProcess.saveInstructions);
		});

		// Proposal Section Headings
		$('#curriculog-fields-column-content').on('click', '.scroller', function(event) {
			if ($(this).hasClass('open')) {
				$(this).removeClass('open').addClass('closed');
				$(this).parent().siblings('ul.section-fields, div.section-add-row').fadeOut('fast', function() {
					domObject.verticalStretchForm(col1, col2);
				});

			} else {
				$(this).addClass('open').removeClass('closed');
				$(this).parent().siblings('ul.section-fields, div.section-add-row').fadeIn('fast', function() {
					domObject.verticalStretchForm(col1, col2);
				});
			}
		});

		// Get the smartfield datasets for the clone
		smartfieldObject.buildDatasets();

		// Fill entities into step restrict entity dialog
		// TODO: The select should show entities hierarchically
		entityObject.entityParentsSelect('#entity-parents-available','select', 1);

		// Size
		domObject.verticalStretchForm(col1, col2);

		// importObject.getCatalogDetails($('#mapImport .catalog-details'));

		// Saving Subheading

		/* this is a hack to make sure that the focusin and focusout gets called only once in
		 * chrome. Without it...it will call it twice and can cause errors in the ajax
		 */
		var _isWindowBlurEvent = false;
		window.onblur = function(e) {
			_isWindowBlurEvent = true;
		};

		window.onfocus = function(e) {
			_isWindowBlurEvent = false;
		};

		$('#curriculog-fields-column-content').on('focusin', '.fields-subheading, .fields-description', function(event) {
			event.preventDefault();
			event.stopPropagation();

			initialInputValue = $(this).attr('value');
		});

		$('#curriculog-fields-column-content').on('focusout', '.fields-subheading, .fields-description', function(event) {
			event.preventDefault();
			event.stopPropagation();

			if (_isWindowBlurEvent) {
				return;
			}

			subsequentInputValue = $(this).attr('value');
			if (initialInputValue !== subsequentInputValue) {
				var fieldsetId = $(this).parents('fieldset').attr('id');
				var fieldDOMId = $(this).attr('id');
				var id = fieldDOMId.replace('field-','');
				approvalProcessObject.updateInstructions(fieldsetId, fieldDOMId, id);
			}
		});

		// Fields
		$('#curriculog-fields-column-content').on('click', '.section-widget', function(event) {
			event.preventDefault();
			event.stopPropagation();
			var action = ($(this).attr('class')).match(/(\w*)-section/);
			approvalProcessObject[action[1] + 'Section'](this);
		});

		$('#curriculog-fields-column-content').on('click', '.row-widget', function(event) {
			event.preventDefault();
			event.stopPropagation();
			var action = ($(this).attr('class')).match(/(\w*)-row/);
			approvalProcessObject[action[1] + 'Row'](this);
		});

		$('#curriculog-fields-column-content').on('click', '.add-field', function(event) {
			event.preventDefault();
			event.stopPropagation();
			approvalProcessObject.addField(this);
		});

		$('#curriculog-fields-column-content').on('click', '.field-options', function(event) {
			event.preventDefault();
			event.stopPropagation();
			approvalProcessObject.showOptions(this,'update');
		});

		$('#curriculog-fields-column-content').on('click', '.option-widget', function(event) {
			event.preventDefault();
			event.stopPropagation();
			var action = ($(this).attr('class')).match(/(\w*)-option/);
			approvalProcessObject[action[1] + 'Option'](this);
		});

		// Saving options
		$('#curriculog-fields-column-content').on('focusin', '.checkbox-radio-label', function(event) {
			initialOptionValue = $(this).attr('value');
		});

		$('#curriculog-fields-column-content').on('focusout', '.checkbox-radio-label', function(event) {
			subsequentOptionValue = $(this).attr('value');
			if (initialOptionValue != subsequentOptionValue) {
				var id = $(this).closest('fieldset').attr('id').replace('fieldset-','');
				var orderIndex = $(this).prev('.checkbox-radio-option').attr('id').replace('field-' + id + '-', '');
				var value = $(this).val();
				approvalProcessObject.updateOption(id, orderIndex, value);
			}
		});


		// Drag n Drop
		$('#curriculog-fields-column-content ul').sortable({
			placeholder: 'curriculog-draggable-placeholder',
			items: '.section-row:not(.non-sortable)',
			handle: '.section-row-draggable-handle',
			connectWith: '.section-fields',

			update: function(event, ui) {
				approvalProcessObject.updateFieldsOrder($(ui.item).parents('fieldset').attr('id'));
			}
		});

		// Radio/Checkbox Active State
		$('#curriculog-fields-column-content').on('mouseenter', '.option-group', function(event) {
			$(this).children('.remove-option').addClass('active');
		});

		$('#curriculog-fields-column-content').on('mouseleave', '.option-group', function(event) {
			$(this).children('.remove-option').removeClass('active');
		});

		// Add Field Dialog
		$('#curriculog-dialog-add-field').on('click', '.select-field', function(event) {
			event.preventDefault();
			event.stopPropagation();
			$('#curriculog-dialog-add-field .select-field').removeClass('active');
			$(this).addClass('active');
		});

		// Save Section Headers
		$('#curriculog-fields-column-content').on('focusin', 'input[id^="section"][id$="displayText"]', function(event) {
			event.stopPropagation();
			initialInputValue = $(this).attr('value');
		});

		$('#curriculog-fields-column-content').on('focusout', 'input[id^="section"][id$="displayText"]', function(event) {
			event.stopPropagation();
			subsequentInputValue = $(this).attr('value');
			if (initialInputValue !== subsequentInputValue) {
				approvalProcessObject.updateSection(this);
			}
		});

		$('.smartfield-option').on('change', 'select', function(){
			if ($(this).val() === 'newCustomType') {
				// debug
				smartfieldObject.editSmartfieldDatasetValues(6);
			}
		});
	};


	objApprovalProcess.unbindFieldEvents = function() {
		$('.fields-description').each(function() {
			$(this).ckeditorGet().destroy();
		});

		$('#curriculog-fields-column-content')
			.off('click', '.scroller')
			.off('focusin', '.fields-subheading, .fields-description')
			.off('focusout', '.fields-subheading, .fields-description')
			.off('click', '.section-widget')
			.off('click', '.row-widget')
			.off('click', '.add-field')
			.off('click', '.field-options')
			.off('click', '.option-widget')
			.off('focusin', '.checkbox-radio-label')
			.off('focusout', '.checkbox-radio-label')
			.off('mouseenter', '.option-group')
			.off('mouseleave', '.option-group')
			.off('focusin', 'input[id^="section"][id$="displayText"]')
			.off('focusout', 'input[id^="section"][id$="displayText"]');

		if ($('#curriculog-fields-column-content ul:data(sortable)').length > 0) {
			$('#curriculog-fields-column-content ul').sortable('destroy');
		}
		$('#curriculog-dialog-add-field').off('click', '.select-field');
		$('.smartfield-option').off('change', 'select');
	};


	/*
	 * Function launchProposal
	 * Purpose: When user launches a proposal, this dialog will launch showing them their workflow and asking them to confirm.
	 */
	objApprovalProcess.launchProcess = function(callback) {
		var errors = '';
		// First, check the following:
		// 1.) Does the item have steps?
		//    a.) Do those steps have roles?
		// 2.) Does the item have a title defined

		objApprovalProcess.checkConditional(function() {
			var dialog = objDialog.createDOMDialog('launch-process-dialog', function(dialog, defaults) {
				// Actions
				$(dialog).find('ul.ap-launch-errors').remove();
				defaults.buttons = {
					'Launch Approval Process': function() {
						$(dialog).find('ul.ap-launch-errors').remove();
						// set to launch
						$('input[name="status"]').val('active');

						$.ajax({
							url: '/admin/approvalProcess:' + $('input[name="id"]').val() + '/launch.json',
							type: 'PUT',
							beforeSend: function() {
								//$('button[name="launch"]').attr('disabled',true);
							},
							complete: function() {
								//$('button[name="launch"]').remove();
							},
							success: function(data) {
								if (data.success > 0) {
									$(dialog).dialog('close');
									objDom.addMask('curriculog-fields-column');
									objDom.addMask('curriculog-steps-column');

									setFlashMessage({
										title: 'Approval Process Launched',
										text: 'Your Approval Process has been launched and ' +
												'is now active for creating proposals against.',
										callback: function() {
											window.location.reload();
										}
									});

								} else {
									var errors = '<ul class="ap-launch-errors">';
									$.each(data.errors, function(index, error) {
										errors += '<li>' + error + '</li>';
									});
									errors += '</ul>';
									$(dialog).append(errors);
									$(dialog).parent().find('.ui-dialog-buttonset .ui-button:eq(0)').attr('disabled',true);
								}
							}
						});
					},
					Cancel: function() {
						$(dialog).find('ul.ap-launch-errors').remove();
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});
		});
	};

	/*
	 * Function reLaunchProposal
	 * Purpose: When user is done using edit mode they can choose to relauch which pops up this dialog box.
	 */
	objApprovalProcess.reLaunchProcess = function(callback) {
		var errors = '';

		objApprovalProcess.checkConditional(function() {
			var dialog = objDialog.createDOMDialog('relaunch-dialog', function(dialog, defaults) {
				// Actions
				$(dialog).find('ul.ap-launch-errors').remove();

				defaults.buttons = {
					'Re-Launch Approval Process': function() {
						$(dialog).find('ul.ap-launch-errors').remove();
						// set to launch
						$('input[name="status"]').val('active');

						$.ajax({
							url: '/admin/approvalProcess:' + $('input[name="id"]').val() + '/relaunchIgnore.json',
							type: 'PUT',
							beforeSend: function() {
								$(dialog).parent().find('.ui-dialog-buttonset .ui-button:eq(0)').attr('disabled',true);
							},
							success: function(data) {
								if (data.success > 0) {
									$(dialog).dialog('close');
									objDom.addMask('curriculog-fields-column');
									objDom.addMask('curriculog-steps-column');

									callback && callback();

									window.location.reload();

								} else {
									reload = false;
									var errors = '<ul class="ap-launch-errors">';
									$.each(data.errors, function(index, error) {
										if (error == 'Your Approval Process is already active and cannot be relaunched') {
											reload = true;
										}
										errors += '<li>' + error + '</li>';
									});
									errors += '</ul>';
									$(dialog).append(errors);
									$(dialog).parent().find('.ui-dialog-buttonset .ui-button:eq(0)').attr('disabled',true);

									// if status was active, automatically reload the AP
									if (reload) {
										setTimeout(window.location.reload(), 4000);
									}
								}
							}
						});

					},
					/*'Force Active Proposals': function() {

					},*/
					Cancel: function() {
						$(dialog).find('ul.ap-launch-errors').remove();
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);

			});
		});
	};

	/*
	 * Function enterEditMode
	 * Purpose: When user launches an ap, this dialog will launch showing them their workflow and asking them to confirm.
	 */

	objApprovalProcess.enterEditMode = function(status, callback) {
		var dialog;
		var hermes = $('input[name="hermes"]').val();

		if (status === 'active') {

			dialog = objDialog.createDOMDialog('exit-edit-dialog', function(dialog, defaults) {
				// Actions
				defaults.buttons = {
					'Exit Edit Mode': function() {

						id = $('input[name="id"]').val();

						$.ajax({
							url: '/admin/approvalProcess:' + id + '/editmode.json',
							type: 'PUT',
							data: {status:status},
							success: function(data) {
								var url = window.location.pathname.split("/");
								var id = url[2].split(":")[1];

								setFlashMessage({
									title: 'Approval Process Has Exited Edit Mode',
									text: 'Your Approval Process is now Active',
									callback: function () {
										location.href = '/admin/approvalProcess:' + id + '/form';
									},
								});

								// get url
								var url = window.location.pathname.split("/");
								var id = url[2].split(":");

								location.href = '/admin/approvalProcess:' + id[1] + '/form';
								callback && callback();

							}
						});

						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);

			});

		} else if (status === 'editing' && hermes === '1') {
			dialog = objDialog.createDOMWarningDialog('edit-process-dialog', function(dialog, defaults) {
				// Actions
				defaults.buttons = {
					'Enter Edit Mode': function() {
						objApprovalProcess.editMode();
						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);

			});
		} else {
			objApprovalProcess.editMode();
		}
	};


	objApprovalProcess.editMode = function() {

		id = $('input[name="id"]').val();

		$.ajax({
			url: '/admin/approvalProcess:' + id + '/editmode.json',
			type: 'PUT',
			data: {status:status},
			success: function(data) {
				setFlashMessage({
					title: 'Approval Process In Edit Mode',
					text: 'Your Approval Process is now in Edit Mode',
					callback: function () {
						location.href = '/admin/approvalProcess:' + id + '/form';
					},
				});
			}
		});

	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***								STEP FUNCTIONS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/*
	* Function newStep
	* Purpose: It builds a new step in its entirety and inserts it into the DOM at the top of the list of steps
	*/
	objApprovalProcess.newStep = function() {
		// get orderIndex
    var domIndex = $('#steps .step:last').index();
		var data = {
			orderIndex : domIndex + 2,
			stepName : 'New Step',
			display: 'getStep'
		};

		$.ajax({
			url: '/admin/approvalProcessStep:' + $('input[name="id"]').val() + '/create.ajax',
			type: 'POST',
			data: data,
			beforeSend: function() {
				objApprovalProcess.unbindStepEvents();
			},
			success: function(data) {
				objApprovalProcess.getStep(data, id);
				Curriculog.Actions.log('ap-step-added');
			}
		});
	};

	/*
	 * Function: closeSteps
	 * Purpose: Close every step, hiding their form content
	 */
	objApprovalProcess.closeSteps = function() {
		$('#curriculog-steps-column-content .step').removeClass('open-step');
		$('#curriculog-steps-column-content .step:not(#curriculog-steps-column-step-clone)').each(function() {
			var id = ($(this).attr('id')).replace('step-','');
			$(this).children('.step-title').html($('#step-' + id + '-name').val());
		});
		objApprovalProcess.verticalStretch();
	};

	/*
	 * Function: toggleStep
	 * Purpose: Open or close a step, showing or hiding their form content
	 */
	objApprovalProcess.toggleStep = function(obj) {
		$(obj).parent('.step').toggleClass('open-step');
		objApprovalProcess.verticalStretch();
	};

	objApprovalProcess.toggleSummary = function(obj) {
		var isToggled = $(obj).parent('div').children('.step-summary-block').hasClass('open-summary');

		// check to see if its already toggled
		if (isToggled) {
			$(obj).parent('div').children('.step-summary-block').removeClass('open-summary');
			$(obj).children('div').removeClass('down');
			$(obj).children('div').addClass('up');

		} else {
			$(obj).parent('div').children('.step-summary-block').addClass('open-summary');
			$(obj).children('div').removeClass('up');
			$(obj).children('div').addClass('down');

			objApprovalProcess.verticalStretch();
		}
	};

	/*
	 * Function: updateStepsOrder
	 * Purpose: Updates ordering of steps.
	 */
	objApprovalProcess.updateStepsOrder = function(fieldsetId) {

		var orderIndexes ={};
		var stepID;

		// update all indexes
		$('#steps .step').each(function(index) {
			stepID = $(this).attr('id').replace('step-','');
			orderIndexes[index+1] = stepID;
		});

		// update all indexes
		$('#' + fieldsetId).children('ul').children('li').each(function(index) {
			if ($(this).children('.section-fieldset').attr('id') !== undefined) {
				fieldID = $(this).children('.section-fieldset').attr('id').replace('fieldset-','');
				orderIndexes[index+1] = fieldID;
			}
		});

		$.ajax({
			url: '/admin/approvalProcessStep:' + $('input[name="id"]').val() + '/updateStepsOrder.json',
			type: 'PUT',
			data: {orderIndexes:orderIndexes},
			success: function(data) {

			}
		});
	};


	/*
		updateStep: update the individual fields of a step and reloads the DOM for the step (if necessary).
		Used for both ap and proposal (custom routes), with type defaulting to approvalProcess.
	*/

	objApprovalProcess.updateStep = function(id, field, type) {
		if (type === undefined) {
			type = 'approvalProcess';
		}

		var step = $('#step-' + id);

		// fieldList is a list of the fields that require a page reload to render properly
		var fieldList = [
			'step[' + id + '][name]',
			'step[' + id + '][mandatory]',
			'step[' + id + '][mandatory][type]',
			'step[' + id + '][deadline]'
		];

		var stepNeedsReload = $.inArray(field, fieldList) !== -1;

		// if we changed the step conditional field or turned mandatory off, reload the form
		var formNeedsReload = field.lastIndexOf('step[' + id + '][mandatory]', 0) === 0;

		var work = [];
		if ($('#step-' + id + '-work-edit:checked').length) {
			work.push($('#step-' + id + '-work-edit').val());
		}

		if ($('#step-' + id + '-work-public:checked').length) {
			work.push($('#step-' + id + '-work-public').val());
		}


		var decisionFlags = [];
		if ($('#step-' + id + '-flag-hold').is(':checked')) {
			decisionFlags.push($('#step-' + id + '-flag-hold').val());
		}

		if ($('#step-' + id + '-flag-cancel').is(':checked')) {
			decisionFlags.push($('#step-' + id + '-flag-cancel').val());
		}

		if ($('#step-' + id + '-flag-custom').is(':checked')) {
			decisionFlags.push($('#step-' + id + '-flag-custom').val());
		}

		if ($('#step-' + id + '-flag-suspend').is(':checked')) {
			decisionFlags.push($('#step-' + id + '-flag-suspend').val());
		}

		var reminders = [];
		if ($('#step-' + id + '-reminder-before-value').val() !== '') {
			reminders.push('before');
		}

		if ($('#step-' + id + '-reminder-after-value').val() !== '') {
			reminders.push('after');
		}

		if ($('#step-' + id + '-reminder-every-value').val() !== '') {
			reminders.push('every');
		}

		if (reminders.length === 0) {
			reminders.push('none');
		}

		var openNodes = [];
		$('#step-' + id + ' .step-summary-toggle .down').each(function(index, summary) {
			openNodes.push($(summary).closest('fieldset').attr('id'));
		});

		// validate step fields

		$.validity.start();

		$('.step-name-input').require().assert(function(){
				return $('.step-name-input').val().trim().length > 0;
		}, "This field is required.");

		if ($('#step-' + id + '-mandatory-type').val() === 'number') {
			$('#step-' + id + '-mandatory-condition-value').match('integer');
		}
		if ($('#step-' + id + '-deadline-type').val() !== '') {
			$('#step-' + id + '-deadline-value').match('integer');
		}
		if ($('#step-' + id + '-reminder-before-value').val() !== '') {
			$('#step-' + id + '-reminder-before-value').match('integer');
		}
		if ($('#step-' + id + '-reminder-every-value').val() !== '') {
			$('#step-' + id + '-reminder-every-value').match('integer');
		}
		if ($('#step-' + id + '-reminder-after-value').val() !== '') {
			$('#step-' + id + '-reminder-after-value').match('integer');
		}

		var outOfRangeMsgVote = 'Vote Threshold must be a number between 1 and 100.';
		var outOfRangeMsgParticipation = 'Participation Threshold must be a number between 1 and 100.';

		if ($('#step-' + id + '-voteThreshold').val() !== '') {
			$('#step-' + id + '-voteThreshold').match('integer').range(1, 100, outOfRangeMsgVote);
		}

		if ($('#step-' + id + '-participationThreshold').val() !== '') {
			$('#step-' + id + '-participationThreshold').match('integer').range(1, 100, outOfRangeMsgParticipation);
		}

		var result = $.validity.end();

		if (result.valid === false) {
      // move validation messages from inside the form label to after the label
      $('span.error').each(function(index){
        var formLabel = $(this).closest('label');
        formLabel.after($(this));
      });
			return;
		}

		/* Conditions Check */
		var mandatoryField = $('input[name="step[' + id + '][mandatory]"]:checked').val();

		var mandatory;
		if (mandatoryField === undefined) {
			mandatory = true;
		} else {
			mandatory = mandatoryField === '1' ? true : false;
		}
		var conditionalFieldID = +$('#step-' + id + '-mandatory-field').val();
		// Note: !conditionFieldID is used here because it will eval as true for
		// null, undefined, NaN, and 0.

		if (mandatory || !conditionalFieldID) {
			conditionalFieldID = null;
		} else if ( field.indexOf("[mandatory][field]") !== -1 ) {
			stepNeedsReload = true;
		}

		/* Decision type */

		var decisionType;
		if ($('input[name="step[' + id + '][decisionType]"]:checked').val() == 'participation'){
			decisionType = 'majority';
		} else{
			decisionType = $('input[name="step[' + id + '][decisionType]"]:checked').val()
		}

		var voteThreshold;
		if ($('#step-' + id + '-decision-vote').is(':checked')) {
			voteThreshold = $('#step-' + id + '-voteThreshold').val();
		} else if ($('#step-' + id + '-decision-participation').is(':checked')) {
			voteThreshold = 50;
		}	

		var stepData = {
			display: 'getStep',
			openNodes: openNodes,
			id: +id,
			name: $('#step-' + id + '-name').val(),
			mandatory: mandatory,
			conditionFieldID: conditionalFieldID,
			mandatoryType: ($('input[name="step[' + id + '][mandatory]"]:checked').val() == '0') ?
				$('#step-' + id + '-mandatory-type').val() : 'string',
			mandatoryCondition: ($('input[name="step[' + id + '][mandatory]"]:checked').val() == '0') ?
				$('#step-' + id + '-mandatory-condition').val() : 'greater',
			conditionValue: ($('input[name="step[' + id + '][mandatory]"]:checked').val() == '0') ?
				$('#step-' + id + '-mandatory-condition-value').val() : '',
			workAllowed: work,
			signature: ($('#step-' + id + '-signature:checked').length) ? 1 : 0,
			agenda: ($('#step-' + id + '-agenda:checked').length) ? 1 : 0,
			userTransparency: $('#step-' + id + '-userTransparency').val(),
			decisionType: decisionType,
			voteThreshold: voteThreshold ? voteThreshold : 0,
			participationThreshold: ($('#step-' + id + '-decision-participation').is(':checked')) ? $('#step-' + id + '-participationThreshold').val() : '100',
			decisionFlags: decisionFlags,
			rejectionRoute: $('#step-' + id + '-route-reject').val(),
			deadlineRoute: ($('input[name="step[' + id + '][deadlineRoute]"]:checked').val() !== undefined) ?
				$('input[name="step[' + id + '][deadlineRoute]"]:checked').val() : 'approve',
			deadline: ($('#step-' + id + '-deadline:checked').length) ? 1 : 0,
			reminder: reminders,
			deadlineDays: parseInt( (($('#step-' + id + '-deadline-value').val() !== '') ? $('#step-' + id + '-deadline-value').val() : 0), 10),
			reminderBeforeDays: parseInt( (($('#step-' + id + '-reminder-before-value').val() !== '') ? $('#step-' + id + '-reminder-before-value').val() : 0), 10),
			reminderEveryDays: parseInt( (($('#step-' + id + '-reminder-every-value').val() !== '') ? $('#step-' + id + '-reminder-every-value').val() : 0), 10),
			reminderAfterDays: parseInt( (($('#step-' + id + '-reminder-after-value').val() !== '') ? $('#step-' + id + '-reminder-after-value').val() : 0), 10),
			customRoutePosition: $('[id^="step-' + id + '-route"]:checked').val()
		};

    // smartfield condition values are saved in a separate data attribute to prevent browser crashing for long option values
    // so we have to retrieve it here
    if ( $('#step-' + id + '-mandatory-condition-value').attr('data-mandatory-type') === 'smartfield' ) {

      stepData.conditionValue = $('#step-' + id + '-mandatory-condition-value :selected').attr('data-smartfield-value');
    }

		// If we require a reload (conditionals, agendas, deadlines), load with ajax.
		// Else execute the save with json and leave DOM alone
		var url = '';
		if (type === 'proposal') {
			url += '/proposal:' + id + '/pendingRoute';
		} else {
			url += '/admin/approvalProcessStep:' + id + '/updateStep';
		}

		if (stepNeedsReload) {
			url += '.ajax';
		} else {
			url += '.json';
		}

		if (! $('#step-' + id + '-decision-vote').is(':checked')) {
			$('#step-' + id + '-voteThreshold').val('');
		}

		if (! $('#step-' + id + '-decision-participation').is(':checked')) {
			$('#step-' + id + '-participationThreshold').val('');
		}


		$.ajax({
			url: url,
			type: 'PUT',
			data: JSON.stringify(stepData),
			contentType: 'application/json',

			beforeSend: function () {
				if (stepNeedsReload) {
					objApprovalProcess.unbindStepEvents();
					objDom.addMask('#step-' + id);
				}
			},

			success: function (data) {
				if (formNeedsReload) {
					objApprovalProcess.updateForm();
				}
				if (stepNeedsReload) {
					objApprovalProcess.getStep(data, id, type);
				}

				objApprovalProcess.verticalStretch();
				Curriculog.Actions.log('ap-step-updated');
			}
		});
	};

	objApprovalProcess.validateVoteAndParticipation = function(id) {

		$.validity.start();
		var outOfRangeMsgVote = 'Vote Threshold must be a number between 1 and 100.';
		var outOfRangeMsgParticipation = 'Participation Threshold must be a number between 1 and 100.';

		if ($('#step-' + id + '-decision-vote').is(':checked') && $('#step-' + id + '-voteThreshold').val() !== '') {
			$('#step-' + id + '-voteThreshold').match('integer').range(1, 100, outOfRangeMsgVote);
		}

		if ($('#step-' + id + '-decision-participation').is(':checked') && $('#step-' + id + '-participationThreshold').val() !== '') {
			$('#step-' + id + '-participationThreshold').match('integer').range(1, 100, outOfRangeMsgParticipation);
		}

		var result = $.validity.end();

		return result.valid;
	};

	objApprovalProcess.validateStepsFields = function(id) {


		$.validity.start();

		$('.step-name-input').require().assert(function(){
				return $('.step-name-input').val().trim().length > 0;
		}, "This field is required.");

		if ($('#step-' + id + '-mandatory-type').val() === 'number') {
			$('#step-' + id + '-mandatory-condition-value').match('integer');
		}
		if ($('#step-' + id + '-deadline-type').val() !== '') {
			$('#step-' + id + '-deadline-value').match('integer');
		}
		if ($('#step-' + id + '-reminder-before-value').val() !== '') {
			$('#step-' + id + '-reminder-before-value').match('integer');
		}
		if ($('#step-' + id + '-reminder-every-value').val() !== '') {
			$('#step-' + id + '-reminder-every-value').match('integer');
		}
		if ($('#step-' + id + '-reminder-after-value').val() !== '') {
			$('#step-' + id + '-reminder-after-value').match('integer');
		}

		var result = $.validity.end();
		return result.valid;

	};

	objApprovalProcess.getSteps = function() {
		var id = $('input[name="id"]').val();

		$.ajax({
			url: '/admin/approvalProcess:' + id + '/form',
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-steps-column-content');
				objApprovalProcess.unbindStepEvents();
			},
			success: function(data) {
				$('#steps').contents().remove();
				$(data).find('#steps').contents().appendTo('#steps');

				objDom.removeMask('#curriculog-steps-column-content');
				objApprovalProcess.bindStepEvents();
				objApprovalProcess.verticalStretch();
			}
		});
	};

	objApprovalProcess.getStep = function(data, id, type) {
		if ($('#step-' + id).length) {
			var stepContents = $(data).filter('#step-' + id).html();
			var stepClasses = $(data).filter('#step-' + id).attr('class');
			$('#step-' + id).html(stepContents);
			$('#step-' + id).attr('class', stepClasses).addClass('open-step');
		} else {
			$(data).insertBefore($('#curriculog-steps-column-new-step'));
		}

		// clean up
		objDom.removeMask('#step-' + id);
		objApprovalProcess.bindStepEvents(type);
		objApprovalProcess.verticalStretch();
	};

	/*
	 * Function: removeStep
	 * Purpose:
	 */
	objApprovalProcess.removeStep = function(obj) {
		var dialog = objDialog.createBasicWarningDialog('curriculog-dialog-remove-step-warning', function(dialog, defaults) {

			// Message
			$(dialog).append('<p>Are you sure you want to remove the step <span class="strong">' + $(obj).closest('.step').find('.step-title').text() + '</span>?</p>');
			$(obj).parents('.step').addClass('curriculog-remove-warning-highlight');

			// Actions
			defaults.buttons = {
				'Delete Step': function() {
					var id = ($(obj).parents('li').attr('id')).replace('step-','');

					$.ajax({
						url: '/admin/approvalProcessStep:' + $('input[name="id"]').val() + '.json',
						type: 'DELETE',
						data: {id:id},
						beforeSend: function() {
							//objDom.addMask($(obj).parents('li').attr('id'));
						},
						complete: function() {
							//objDom.removeMask($(obj).parents('li').attr('id'));
						},
						success: function(data) {
							if (parseInt(data.conditionalFieldId) !== 0)
								$('#fieldset-' + data.conditionalFieldId).removeClass("conditional-field");

							objApprovalProcess.verticalStretch();
							Curriculog.Actions.log('ap-step-deleted');
						}
					});

					$(obj).parents('.step').remove();
					$(this).dialog('close');
				},
				Cancel: function() {
					$(obj).parents('.step').removeClass('curriculog-remove-warning-highlight');
					$(this).dialog('close');
				}
			};

			defaults.close = function(event, ui) {
				$(this).remove();
			};
			$(dialog).dialog(defaults);
		});
	};

	objApprovalProcess.bindStepEvents = function(type) {
		if (type === undefined) {
			type = 'approvalProcess';
		}

		var options = {
			'buttonText': 'Add Participant',
			'dbData': '',
			'type': type,
			'showUsers':true,
			'showRoles':true,
			'showRoleTypes':true,
			'selectOne': false,
			'selectEmpty':true,
		};

		if (type === 'proposal') {
			options.selectOne = false;
			options.selectEmpty = false;
			options.selectionRequired = true;
		}

		// Click Event for opening the participant dialog.
		$('.participant-picker').participantpicker(options);

		$stepsColumnContent = $('#curriculog-steps-column-content');
		// Toggle step summaries
		$stepsColumnContent.on('click', '.step-summary-toggle', function(event) {
			approvalProcessObject.toggleSummary(this);

			var id = $(this).closest('li.step').attr('id').replace('step-', '');
			var mandatoryField = $('input[name="step[' + id + '][mandatory]"]:checked').val();

			if (($(this).hasClass('mandatory-summary')) && ($(this).find('.down').length > 0)) {
				objApprovalProcess.updateConditionalDropdowns();
			}

		});
		$stepsColumnContent.on('keyup', '.step-summary-toggle', function(event) {
			if ( event.which === 13 ){
				approvalProcessObject.toggleSummary(this);

				var id = $(this).closest('li.step').attr('id').replace('step-', '');
				var mandatoryField = $('input[name="step[' + id + '][mandatory]"]:checked').val();

				if (($(this).hasClass('mandatory-summary')) && ($(this).find('.down').length > 0)) {
					objApprovalProcess.updateConditionalDropdowns();
				}
			}
		});

		// Save Step Fields
		$stepsColumnContent.on('change', 'input[id^="step"], select[id^="step"]', function(event) {
			event.stopPropagation();

			$.validity.start();
			$('.step-name-input').require();
			var result = $.validity.end();
			if (!result.valid) {
				return;
			}
			var id = $(this).closest('li.step').attr('id').replace('step-', '');
			var field = $(this).attr('name');
			approvalProcessObject.updateStep(id, field, type);
		});

		$('.steps-tab').on('click', 'a', function(e) {
			e.preventDefault();
			e.stopPropagation();
		});

		$stepsColumnContent.on('click', '.add-step', function(e) {
			e.preventDefault();
			approvalProcessObject.closeSteps();
			approvalProcessObject.newStep();
		});

		$stepsColumnContent.on('click', '.remove-step', function(e) {
			e.preventDefault();
			approvalProcessObject.removeStep(this);
		});

		$stepsColumnContent.on('click', '.step-titlebar', function(e) {
			e.preventDefault();
			approvalProcessObject.toggleStep(this);
		});
		$stepsColumnContent.on('keyup', '.step-titlebar', function(e) {
			if ( e.which === 13 ){
				e.preventDefault();
				approvalProcessObject.toggleStep(this);
			}
		});
	};

	objApprovalProcess.unbindStepEvents = function() {
		$('#curriculog-steps-column-content').off('click', '.step-summary-toggle');
		$('#curriculog-steps-column-content').off('keyup', '.step-summary-toggle');
		$('#curriculog-steps-column-content').off('change', 'input[id^="step"], select[id^="step"]');
		$('.steps-tab').off('click', 'a');
		$('#curriculog-steps-column-content').off('click', '.add-step');
		$('#curriculog-steps-column-content').off('click', '.remove-step');
		$('#curriculog-steps-column-content').off('click', '.step-titlebar');
		$('#curriculog-steps-column-content').off('keyup', '.step-titlebar');
	};



	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***						TITLE AND DESCRIPTION FUNCTIONS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	objApprovalProcess.getTitlesFromDB = function() {
		// get the id of approval proposal
		var id = $('input[name="id"]').val();
		var titlesSorted = [];
		var titleIds = [];

		$('#title-selection').contents().remove();

		$.ajax({
			url: '/admin/approvalProcess:' + id + '/title.json',
			type: 'GET',
			async: false,
			beforeSend: function() {
				objDom.addMask('title-selection','Loading...Please Wait');
			},
			success: function(data) {
				$.each(data.approvalProcess, function(index,fields) {
					$.each(fields, function(indx,field) {
						if ((field !== null) && (field['title'] >= 1)) {
							var title = {
								id: field['id'],
								name: field['displayText']
							};

							titlesSorted[field['title']] = title;
							titleIds.push(parseInt(field['id'], 10));
						}
					});
				});

				if (titlesSorted.length !== 0) {
					$.each(titlesSorted, function(order, title) {
						if (title !== undefined) {
							var titleElement = $('<li class="box-item"><span>' +
								'<label for="title-' + title['id'] + '-name" >' + _.escape(title['name']) + '</label>' +
								'<input id="title-' + title['id'] + '-name" type="hidden" name="" value="' + _.escape(title['name']) + '" />' +
								'<input id="title-' + title['id'] + '" type="hidden" name="" value="' + title['id'] + '" />' +
								'</span></li>');
							$('#title-selection').append(titleElement);
						}
					});
				}

				objDom.removeMask('title-selection');
			}
		});

		return titleIds;
	};

	objApprovalProcess.populateTitleDialog = function() {

		var titleIds = objApprovalProcess.getTitlesFromDB();

		$("#curriculog-steps-column-available-titles").contents().remove();

		// cycle through the fields and return only the text and smartfield items
		$('#curriculog-fields-column-content .text-textarea-smartfield').each(function(index, item) {
			var id = $(item).attr('id').replace('fieldset-','');
			var fieldType = $('#field-' + id + '-fieldType').val();
			var systemRequired = $('#field-' + id + '-systemRequired').val();
			var excludedFields = ['proposalObjectives','proposalOutcomes','prospectiveCurriculum'];

			if ((_.contains(['text','smartfield'], fieldType)) && (! _.contains(excludedFields, systemRequired))) {
				var label;
				if (fieldType == 'text') {
					label = _.escape($('#field-' + id).prev('label').text());
				} else {
					label = _.escape($('#field-' + id).parents('div').prev('label').text());
				}

				var titleElement = $('<li class="box-item">' +
					'<label for="title-' + id + '-name" >' + label + '</label>' +
					'<input id="title-' + id + '-name" type="hidden" name="" value="' + label + '" />' +
					'<input id="title-' + id + '" type="hidden" name="" value="' + id + '" />' +
					'</li>');

				if (! _.contains(titleIds, parseInt(id, 10))) {
					$("#curriculog-steps-column-available-titles").append(titleElement);
				}
			}
		});

		objApprovalProcess.buttonManager();
	};

	objApprovalProcess.buttonManager = function() {
		$('.list-box-buttons div').removeClass('disabled');
		$("#curriculog-steps-select-titles").closest('.ui-dialog').find('button:contains("Save Selection")').prop("disabled", false).removeClass("ui-state-disabled");

		if ($('#title-selection .box-item').length === 3) {
			$('.list-box-add').addClass('disabled');
		}

		if ($('#title-selection .box-item').length === 0) {
			$('.list-box-remove').addClass('disabled');
			$("#curriculog-steps-select-titles").closest('.ui-dialog').find('button:contains("Save Selection")').prop("disabled", true).addClass("ui-state-disabled");
		}
	};

	objApprovalProcess.selectTitles = function() {
		var dialog = objDialog.createDOMDialog('curriculog-steps-select-titles', function(dialog, defaults) {

			defaults.buttons = {
				'Save Selection': function() {
					// get the id of approval proposal
					var id = $('input[name="id"]').val();

					// Get title fields into an array
					var titles = [];
					if ($('#title-selection li input').length > 0) {
						hasTitles = 'yes';
						$('#title-selection li input').not('input[id$="-name"]').each(function(i) {
							titles[i] = $(this).val();
						});
					} else {
						hasTitles = 'no';
					}

					var postData = {
						titles:titles
					};

					$.ajax({
						url: '/admin/approvalProcess:' + id + '/title',
						type: 'PUT',
						data: postData,
						success: function() {
							// make sure we change the hasTitle to yes
							if (hasTitles == 'yes') {
								$('#hasTitle').val('yes');

							} else {
								$('#hasTitle').val('no');
							}

							// When we remove a title, we need to also update the hidden field or
							// else the title will be added back again when we edit the field.
							// See ticket #1190

							// if the field isn't a system-required field needed by Acalog, enable the required checkbox
							var acalogRequiredFields = [
								'proposalEntity',
								'coursePrefix',
								'courseCode',
								'courseTitle',
								'programTitle',
								'prospectiveCurriculum',
								'programType'
							];
							$('#curriculog-steps-column-available-titles li input:not([id*="name"])').each(function () {
								id = $(this).val()
								$('#field-' + id + '-title').val(0);
								$('#field-'+ id +'-options').removeClass('title-field');

								var systemRequired = $('#field-' + id + '-systemRequired').val();
								if (! _.contains(acalogRequiredFields, systemRequired)) {
									$('#field-' + id + '-required').prop('disabled', false);
								}
							});

							objApprovalProcess.updateTitleData(titles);
                       }
                   });

                   $(this).dialog('close');
               },
               Cancel: function() {
                   $(this).dialog('close');
               }
           };
           // Cleanup
           defaults.close = function(event, ui) {
               //objApprovalProcess.cleanAddTitleDialog();
           };

           $(dialog).dialog(defaults);

       });
	};

	objApprovalProcess.updateTitleData = function(titles) {
		// update view of title in tab
		$('#title-data').contents().remove();
		$.each(titles, function(order,id) {
			var name = _.escape($('#title-' + id + '-name').val());
			$('#title-data').append($('<li class="item title-' + id + ' title-item">' + name + '</li>'));

			// used for modifying field options
			$('#field-'+ id +'-options').addClass('title-field');

			// update title input in field options
			var value = order + 1;
			$('#field-' + id + '-title').val(value);
		});

		if ($('#title-data').contents().size() <= 0) {
			$('#title-data').append($('<li class="no-item">No Fields have been selected as a Title</li>'));
		}

		// Title Fields and Smartfields default to required.
		// Smarfields default to single select.
		$('.title-field ul li:not(.all-field-types) label').each(function() {
			var optionName = $(this).attr('for').match(/field-(\d*)-(\w*)/);
			var optionType = optionName[2];
			var fieldName = 'field[' + optionName[1] + ']';
			var fieldId = 'field-' + optionName[1];
			var input;

			switch(optionType){
				case 'displayText':
				case 'dataset':
				case 'validation':
				case 'helpText':
				case 'summary':
				case 'searchable':
				case 'userTracking':
					break;
				case 'maxLength':
					// if ($(this).hasClass('smartfield-option')) {
					// 	input = $(this).find('input');
					// 	$(input).attr('disabled', true).attr('checked', true).removeAttr('id');
					// 	$(input).append('<input type="hidden" name="'+ fieldName +'[maxLength]" id="'+ fieldId +'-maxLength" value="1">');
					// }
					break;
				case 'required':
					input = $(this).parent().find('input');
					$(input).attr('disabled', true).attr('checked', true).val("1");
					break;
			}
		});
	};


	objApprovalProcess.updateDesc = function() {
		var id = $('input[name="id"]').val();

		$.ajax({
			url: '/admin/approvalProcess:' + id + '/description.json',
			type: 'PUT',
			data: {description:$('.proposal-description').val()},
			beforeSend: function() {
				objDom.addMask('#proposalDescriptionField','Saving...Please Wait');
			},
			success: function() {
				objDom.removeMask('#proposalDescriptionField');
			}
		});
	};


	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***							UTILITY FUNCTIONS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	objApprovalProcess.toggleWorkTab = function(tab) {
		//reset tabs and their layers
		$('#curriculog-steps-column-tooltabs .tab').removeClass('active');
		$('#curriculog-steps-column-content li.tab-content-item').removeClass('active');
    $('#curriculog-side-menu .tab').removeClass('active');

		$('.'+tab+'-tab').addClass('active');
		$('#'+tab).addClass('active');

		if (tab == 'mapImport') {
			if ($('#hermes').val() === '1') {
				hermesObject.getLegends($('input[name="id"]').val(), function() {
					domObject.verticalStretchForm(col1, col2);
				});
			}
		}

    if (cui_enabled) {
      domObject.adjustCUIFormToolbox(tab);
    }
	};

	objApprovalProcess.verticalStretch = function() {
		var col1 = '#curriculog-fields-column-content';
		var col2 = '#curriculog-steps-column-content';
		domObject = dom();
		domObject.verticalStretchForm(col1, col2);
	};

	/*
	 * Function getfieldName (private)
	 * Purpose: to extract the field's id from the DOM id to insert into the NAME attribute of a field.
	 * getfieldName takes as an argument either:
	 * 1) An empty argument
	 * 2) The Name format field[#####]
	 * 3) The DOMId format field-#####
	 */
	var getFieldName = function(fieldId) {
		var fieldName = '';
		if ((fieldId !== '') && (fieldId !== null)) {
			field = fieldId.match(/field[\\[\-](\d*)(\\])?/);
			if (field !== null) {
				fieldName = 'field['+field[1]+']';
			}
		} else {
			fieldName = 'field['+ myUniquer.create() +']';
		}
		return fieldName;
	};

	/*
	 * Function getFieldDOMId (private)
	 * Purpose: to extract the fieldset's id to apply to all DOM Ids.
	 */

	var getFieldDOMId = function(fieldsetId) {
		FieldDOMId = fieldsetId.replace('fieldset','field');
		return FieldDOMId;
	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***							VALIDATION METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************


	objApprovalProcess.validate = function(input, event, type) {
		var elementValue = $.trim($(input).val());

		var valid = false;
		var required = false;
		var inputType = objValidation.getInputType(input);

		// type of input
		switch(inputType){
			case "checkbox":
			case "radio":
			case "smartfield":
				if ($(input).parents('fieldset:first').hasClass('required')) {
					if (inputType == 'smartfield') {
						if ($(input).siblings('.smartfield-item').size() < 1){
							required = true;
						}
					} else {
						if ( $(input).parents('fieldset:first').find('input:checked').size() < 1) {
							required = true;
						}
					}
				}
				type = '';
				valid = true;
				break;
			default:
				if ($(input).hasClass('required')) {
					if ( objValidation.isEmpty(elementValue) ) {
						required = true;
					}
				}

				if (typeof type == 'undefined') {
					type = '';
					var tempType = $(input).attr('class').match(/validate-(numeric-greater-than-zero|numeric|alpha|email|phone|date)/);
					if (tempType && tempType[1] !== undefined) {
						type = tempType[1].toLowerCase();
					}
				}

				// type of validation
				switch (type) {
					case "numeric":
						if (objValidation.isInteger(elementValue)) {
							valid = true;
						}
						break;
					case "numeric-greater-than-zero":
						if (objValidation.isGreaterThanZero(elementValue)) {
							valid = true;
						}
						break;
					case "alpha":
						if (objValidation.isAlpha(elementValue)) {
							valid = true;
						}
						break;
					case "email":
						if (objValidation.isEmail(elementValue)) {
							valid = true;
						}
						break;
					case "phone":
						if (objValidation.isPhone(elementValue)) {
							valid = true;
						}
						break;
					case "date":
						if (objValidation.isDate(elementValue)) {
							valid = true;
						}
						break;
					default:
						valid = true;
						break;
				}
				break;
		}

		return objValidation.updateForm(input, valid, required, type,

			function() { // removeCallback
				$(input).parents('fieldset:first').removeClass('error');
			},

			function() { // clearFormCallback
				$("#curriculog-steps-column-decisions").find("button").removeAttr('disabled').fadeTo("fast", 1.0);
			},

			function() { // addCallback
				$("#curriculog-steps-column-decisions").find("button").attr('disabled', 'disabled').fadeTo("fast", 0.5);
			});

	};

	return objApprovalProcess;
};
